var BT = {
  selectors: {
    sidebar : {
      btn: '.bt-sidebar-btn',
      box: '.bt-sidebar',
      closeBtnCanvas: '.bt-sidebar__close',
      closeSidebarBtn: '.close-menu-btn',
      openClass: 'open-sidebar-canvas',
      overlayClass: 'overlay--sidebar'
    },
    overlay: '.overlay',
    showOverlayClass: 'show-overlay',
    slider : {
      useTouchMobile: 'use-touch-mobile',
      default: '.use-slider',
      overFloatClasses: 'ov-slider-tb ov-slider-mb hide-in-loading'
    },
    desktopNav: {
      topItem: '.nav__item',
      parentItem: '.nav__item--parent',
      dropdown: '.nav__item__dropdown',
      parentNav: '.header__wrap',
      triangle: '.nav__item__triangle'
    },
    verticalNav: {
      topItem: '.nav__item--ver',
      parentItem: '.nav__item--parent',
      dropdown: '.nav__item__dropdown',
      parentNav: '.main-nav--ver'
    },
    dropdown: {
      wrap: ".bt-dropdown",
      trigger: ".bt-dropdown__trigger",
      content: ".bt-dropdown__content"
    },
    productGroup: {
      wrap: ".pg",
      option: ".pg__option",
      optionValues: ".pg__option__values",
      optionValue: ".pg__option__value",
      mainImg: '.pg__main-image',
      thumbs: '.pg__thumbs',
      thumbsSmallClass: 'pg__thumbs--small',
      thumbsLargeClass: '.pg__thumbs--large',
      thumbsSlider: '.pg__thumbs--slider',
      thumbsSliderVerticalClass: 'pg__thumbs--ver-slider',
      thumb: '.pg__thumb',
      thumbLink: '.pg__thumb__link',
      mains: '.pg__mains',
      mainsSlider: '.pg__mains--slider',
      main: '.pg__main',
      mainLink: '.pg__main__link',
      mainLinkZoom: '.pg__main__link--zoom',
      mainLinkModel: '.pg__main__link--model',
      price: '.product-price',
      cartBtn: '.add-cart-btn',
      cartBtnState: '.add-cart-btn--state',
      variantId: '.variant-id',
      variantTitle: '.pg__variant-title',
      loadingClass: 'loading-data',
      reCalcIndexClass: 're-calc-index',
      countdown: '.pg__countdown-js',
      syncUrl: '.pg__sync-url',
      labelDeal: '.lb-item--sale',
      labelPercent: '.lb__percent',
      optionSub: '.pg__option-sub',
      optionSubValue: '.pg__option-sub__value',
      singleProgress: '.product-single__progress',
      stockText: '.pg__stock-text',
      stockText1: '.pg__stock-text1',
      stockText2: '.pg__stock-text2',
      stockNumber: '.pg__stock-number--update',
      video: '.pg__video',
      videoYoutube: '.pg__video--youtube',
      videoVimeo: '.pg__video--vimeo',
      sku: '.pg__sku',
      ignoreLightBoxClass: 'ignore-lightbox',
      swatchOutStock: 'swatch__item--soldout',
      swatchColorClass: 'swatch--color',
      swatchItemColorClass: 'swatch__item--color',
      storePickupWrap: '.store-availability-container',
      storePickupInner: '.store-availability-inner',
      storePickupBtn: '.store-availability-information__button',
      storePickupModel: '#storePickupPopup',
      storePickupProductTitle: '.store-availabilities-modal__product-title',
      storePickupVariantTitle: '.store-availabilities-modal__variant-title',
      requiredOptionsClass: 'pg__option--required',
      selectedClass: 'selected',
      selectedSelector: '.selected',
      hideClass: 'hide',
      hideSelector: '.hide'
    },
    cart: {
      addBtn: '.add-cart-btn',
      updateBtn: '.update-cart-btn',
      header: '.header__cart',
      headerTriggerDesktop: '.header__cart-trigger-desktop',
      headerTriggerMobile: '.header__cart-trigger-mobile',
      number: '.cart-number',
      total: '.cart-total',
      selectOptionClass: 'select-option',
      qtyInput: '.cart__qty-input'
    },
    qtyBox: {
      ctrlBtn: '.qty-box__ctrl',
      decreaseBtnClass: 'qty-box__ctrl--descrease',
      increaseBtnClass: 'qty-box__ctrl--increase',
      inputSyncClass: 'qty-box__input--sync'
    },
    mediaBtn: '.button--media',
    loadingAjaxClass: 'loading-ajax',
    workingClass: 'working',
    qvBtn: '.button--qv',
    qvPopup: '#quickViewPopup',
    selectOptionBtn: '.button--select-option',
    selectOptionPopup: '#selectOptionPopup',
    compare: {
      popup: '#comparePopup',
      btn: '.button--cp',
      removeBtn: '.button-cp--remove',
      variantId: '.variant-id--compare',
      actionsRow: '.actions-row',
      availabilityRow: '.availability-row',
      headerLink: '.header__link--compare',
      number: '.compare-number',
      cartBtn: '.pg__compare-cart-btn'
    },
    wishlist: {
      popup: '#wishlistPopup',
      btn: '.button--wl',
      btnWithText: '.button--wl-text',
      btnText: '.wishlist-text',
      removeBtn: '.button-wl--remove',
      headerLink: '.header__link--wishlist',
      number: '.wishlist-number'
    },
    waitingData: '.waiting-data', // ignore this element when init slider to wait the data is loaded.
    waitingTabData: '.waiting-tab-data', // load data when the correspoding tab is opened.
    waitingScrollData: '.waiting-scroll-data', // load data when element is visible in viewport.
    loadMoreBtn: '.button--more',
    loadingFull: '.loading-full',
    cartMessage: '.cart-message',
    cartModal: {
      wrap: '#cartModal',
      productImage: '.cart-response__image',
      productName: '.cart-response__name',
      variantTitle: '.cart-response__meta-variant-title-wrap',
      variantProp: '.cart-response__meta-propeties',
      price: '.cart-response__price .product-price__price',
      linePrice: '.cart-response__line-price .product-price__price',
      qty: '.cart-response__qty',
      freeShippingText: '.cart-response__free-shipping__text',
      freeShippingProgressBar: '.progress-bar--popup-cart'
    },
    notify: '.notify',
    notifyClassTypes: 'alert-success alert-danger',
    floatField: '.field--float-label',
    floatFieldFirstFocus: '.first-focus',
    /* Recommended products */
    rp: {
      wrap: '.rp',
      item: '.rp__item',
      minuteNumber: '.rp__minute-number',
      closeBtn: '.rp__close'
    },
    /* Newsletter popup */
    newsPopup: {
      id: '#newsletterPopup',
      checkbox: '#newsPopupHide'
    },
    newsTerms: {
      form: '.newsletter-form',
      input: '.news-terms-input'
    },
    /* Promotion */
    promo: {
      wrap: '.promo',
      closeBtn: '.promo__close',
      list: '.promo__list'
    },
    upsell: {
      wrap: '.upsell-ele',
      list: '.upsell-list'
    },
    related: {
      wrap: '.related-ele',
      list: '.related-list',
    },
    loadingNotFull: '.loading-not-full',
    infiniteScroll: {
      button: '.infinite-scroll',
      wait: '.wait-infinite-scroll'
    },
    cartTerms: {
      wrap: '.cart-terms',
      popup: '#termsPopup',
      checkbox: '.terms-check',
      label: '.cart-terms__label',
      checkoutBtn: '.checkout-btn',
      paymentBtn: '.shopify-payment-button,.additional-checkout-buttons'
    },
    popupVideo: {
      btn: '.video-thumbnail',
      youtubeBtn: '.js-modal-btn--youtube',
      vimeoBtn: '.js-modal-btn--vimeo'
    },
    searchFull: {
      wrap: '.search-full',
      trigger: '.search-full-trigger',
      content: '.search-full__content',
      input: '.search-full__input',
      inputSync: '.search-full__input-sync',
      loading: '.search-full__loading',
      close: '.search-full__close-js',
      tabTitle: '.search-full__tab-title',
      tabList: '.search-full__tab-list',
      tabContent: '.search-full__content__tab',
      result: '.search-full__result',
      loadedClass: 'loaded',
      suggestProducts: '.search-full__suggest-products'
    },
    ajaxSnippet: '.load-ajax-snippet'
  },
  options: {
    dropdown: {
      duration: 150,
      overlaySuffixEvent: 'bt-dropdown',
      noOverLayClass: 'nooverlay'
    },
    sidebar: {
      duration: 300,
      openEvent: 'click',
      closeEvent: 'click',
      overlaySuffixEvent: 'bt-sidebar'
    },
    slider: {
      slidesToShow: 4,
      slidesToScroll: 1,
      //asNavFor: wrap + ' .viewmore-main',
      dots: false,
      //centerMode: true,
      focusOnSelect: false,
      infinite: false,
      swipe: true,
      swipeToSlide: true,
      rtl: rtl,
      nextArrow: '<button aria-label="button" class="slick-next flex flex-align-ver flex-align-hoz slick-arrow--ver-center button--shadow"><i class="slick-arrow__icon slick-arrow__icon--next flex flex-align-hoz"></i></button>',
      prevArrow: '<button aria-label="button" class="slick-prev flex flex-align-ver flex-align-hoz slick-arrow--ver-center button--shadow"><i class="slick-arrow__icon slick-arrow__icon--prev flex flex-align-hoz"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    },
    productGroup: {
      smallSlider: {
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: false,
        focusOnSelect: true,
        centerMode: false,
        rtl: rtl,
        nextArrow: '<button aria-label="button" class="slick-next flex flex-align-ver flex-align-hoz button--shadow slick-arrow--ver-center" type="button"><i class="slick-arrow__icon slick-arrow__icon--next"></i></button>',
        prevArrow: '<button aria-label="button" class="slick-prev flex flex-align-ver flex-align-hoz button--shadow slick-arrow--ver-center" type="button"><i class="slick-arrow__icon slick-arrow__icon--prev"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              vertical:false,
              verticalSwiping:false,
              slidesToShow: 5
            }
          }
        ]
      },
      mainSlider: {
        slidesToShow: 1,
        slidesToScroll: 1,
        //asNavFor: wrap + ' .viewmore-thumbs',
        arrows: false,
        fade: false,
        infinite: false,
        swipeToSlide: true,
        arrows: true,
        adaptiveHeight: true,
        lazyLoad: 'ondemand',
        rtl: rtl,
        nextArrow: '<button aria-label="button" class="slick-next slick-arrow--ver-center flex flex-align-ver flex-align-hoz button--shadow" type="button"><i class="slick-arrow__icon slick-arrow__icon--next"></i></button>',
        prevArrow: '<button aria-label="button" class="slick-prev slick-arrow--ver-center flex flex-align-ver flex-align-hoz button--shadow" type="button"><i class="slick-arrow__icon slick-arrow__icon--prev"></i></button>',
        responsive: [
          {
            breakpoint: 992,
            settings: {
              dots: true,
              arrows: false
            }
          }
        ]
      },
      smallVerticalArrows: {
        next: '<button aria-label="button" class="slick-next flex flex-align-ver flex-align-hoz button--shadow slick-arrow--single-thumbs-vertical slick-arrow--single-thumbs-vertical-next" type="button"><i class="slick-arrow__icon lnr-chevron-down"></i></button>',
        prev: '<button aria-label="button" class="slick-prev flex flex-align-ver flex-align-hoz button--shadow slick-arrow--single-thumbs-vertical slick-arrow--single-thumbs-vertical-prev" type="button"><i class="slick-arrow__icon lnr-chevron-up"></i></button>'
      }
    },
    windowScreen: {
      desktop: 768,
      mobile: 767
    },
    productZoom: {zoomSizeMode: 'image',autoInside:true, tintOpacity: 0, zoomPosition: 'inside'},
    countdown: {
      dealCountdownReg : '([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})',
      dealCountdownTpl : $('#bt_countdown_html').html()
    },
    compare: {
      cookieName: 'bt-compare-new'
    },
    wishlist: {
      cookieName: 'bt-wishlist-new'
    },
    productNameHolder: 'product_title',
    notifyDuration: 300,
    notifyTimeout: 3000,
    notifyClassTypes: {
      success: 'success',
      danger: 'danger'
    },
    rp: {
      cookieName: 'rp_hide',
      duration: 700
    },
    newsPopup: {
      cookieName: 'hide_news_popup'
    },
    promo: {
      cookieName: 'hide_promo'
    },
    cartTerms: {
      cookieName: 'cart_terms'
    },
    newsTerms: {
      cookieName: 'news_terms'
    },
    recentView: {
      cookieName: 'recent_view_products_new'
    },
    overlay: {
      openPrefixEvent: 'showOverlay.',
      hidePrefixEvent: 'hideOverlay.'
    },
    desktopNav: {
      overlaySuffixEvent: 'hoz-megamenu',
      view: 'navigation'
    },
    verticalNav: {
      view: 'navigation-vertical'
    },
    searchFull: {
      suffixEvent: 'search-full'
    }
  },
  data: {
    productGroup: {},
    outStockGroup: {},
    updatingProductOptions: false,
    productVideo: {
      currentPlayer: null,
      currentType: null,
      loadYoutubeApi: false,
      loadVimeoApi: false,
      vimeoPlayers: {}
    },
    productGroupInfiniteScroll: {},
    updateCartRequests: [],
    favicon: null,
    zoom: {
      single: null,
      quickView: null
    },
    rp: {
      openTimeInterval: null
    },
    modalVideoWorking: false,
    loadedSnippets: [],
    thresholdMenu: 0,
    stickyMenuObj: null,
    resizeEventName: 'bt_resize_window',
    scrollEventName: 'bt_scroll_window',
    cacheWindowWidth: $(window).width(),
    isTouchDevide: false,
    thresholdMenuWithPromotion: 33,
    sliderIndex: 0,
    wishlist: {
      loaded: false
    },
    compare: {
      firstLoaded: false
    },
    cookieArray: {},
    pageLoaded: false,
    searchSuggestionCurrentAjaxRequest: null,
    searchSuggestionLoadSuggestedProducts: false,
    customColorCodes: null,
    customColorCodesLoading: false,
    customColorCodesStack: [],
    initTopBar: false,
    ajaxSetup: false,
    openingDesktopNav: false
  },

  shuffleArray: function (d) {
    for (var c = d.length - 1; c > 0; c--) {
      var b = Math.floor(Math.random() * (c + 1));
      var a = d[c];
      d[c] = d[b];
      d[b] = a;
    }
    return d;
  },

  /**
   * Returns a random integer between min (inclusive) and max (inclusive)
   * Using Math.round() will give you a non-uniform distribution!
   */
  getRandomInt: function(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },

  getCookie: function (name) {
    try {
      return $.cookie(name);
    } catch(e) {
    }
  },

  setCookie: function(name, value, expire) {
    try {
      var params = {path: '/'};
      if(expire) {
        params.expires = expire;
      } else {
        params.expires = 7;
      }
      $.cookie(name, value, params);
    } catch(e) {
    }
  },

  stripScripts: function(s) {
    var div = document.createElement('div');
    div.innerHTML = s;
    var scripts = div.getElementsByTagName('script');
    var i = scripts.length;
    while (i--) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
    return div.innerHTML;
  },

  callAjax: function(url, type, data, dataType, cb, cbError) {
    return $.ajax({
      type: type,
      url: url,
      data: data,
      dataType: dataType,
      error: (xhr, textStatus, errorThrown) => {
        this.hideLoadingFull();
        if(xhr.responseJSON != undefined) {
          if(xhr.responseJSON.description != undefined && xhr.responseJSON.description != null) {
            this.showNotify(xhr.responseJSON.description, this.options.notifyClassTypes.danger);
          } else if (xhr.responseJSON.message != undefined) {
            this.showNotify(xhr.responseJSON.message, this.options.notifyClassTypes.danger);
            //showNotifyMsg(xhr.responseJSON.message, 'error');
          }
        }
        if(cbError) {
          cbError();
        }
      },
      success: function(response){
        cb(response);
      }
    });
  },

  renderSectionByAjaxApi: function(sectionId, data, cb) {
    var ajaxData = data;
    ajaxData.section_id = sectionId;
    ajaxData.page = 2;
    this.callAjax(theme.currentUrl, 'GET', ajaxData, null, cb);
  },

  requestUpdateCart: function(line, qty, cb, cbError){
    $(this.data.updateCartRequests).each((index, xhr) => {
      if(xhr && xhr.readyState != 4){
        xhr.abort();
      }
    });
    this.data.updateCartRequests = [];
    this.data.updateCartRequests.push(this.callAjax(theme.cartChangeUrl, 'POST', {line: line, quantity: qty}, 'json', (cart) => {
      if(cb) {
        cb(cart);
      }
    }, cbError));
  },

  requestEmptyCart: function(cb){
    this.callAjax(theme.cartClearUrl, 'POST', {}, 'json', (cart) => {
      if(cb) {
        cb(cart);
      }
    });
  },

  resizeImage: function(t, r) {
    try {
        if ("original" == r) return t;
        var e = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/);
        return e[1] + "_" + r + "." + e[2];
    } catch (r) {
        return t;
    }
  },

  newResizeImage: function(t, w = null, h = null) {
    var suffix = [];
    if(w) {
      suffix.push('width=' + w);
    }
    if(h) {
      suffix.push('height=' + h);
    }
    if(suffix.length > 0) {
      var resize = suffix.join('&');
      if(t.indexOf('?') > -1) {
        return t + '&' + resize;
      }
      return t + '?' + resize;
    }
    return t;
  },

  isInViewport : function(ele, windowEle) {
      var elementTop = ele.offset().top;
      var elementBottom = elementTop + ele.outerHeight();
      var viewportTop = $(windowEle).scrollTop();
      var viewportBottom = viewportTop + $(windowEle).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
  },

  rteWrapTable: function(wrap) {
    //
    wrap.find('table').each((index, table) => {
      $(table).addClass('table table-bordered table-striped').wrap(
        '<div class="table-responsive"></div>'
      );
    });
  },

  rteWrapEmbed: function(wrap) {
    wrap.find('.embed-responsive-item,iframe,embed,object,video').each((index, ele) => {
      /*$(this).wrap(
        '<div class="embed-responsive"></div>'
      );
      this.src = this.src;*/
      $(ele).css('max-width','100%');
    });
  },

  rteWrap: function(wrap) {
    const wrapObj = this.convertStrToObject(wrap);
    if(wrapObj.hasClass('rte-wrapped')) {
      return;
    }
    this.rteWrapTable(wrapObj);
    this.rteWrapEmbed(wrapObj);
    wrapObj.addClass('rte-wrapped');
  },
  convertStrToObject(wrap) {
    if(typeof wrap == 'string') {
      return $(wrap);
    }
    return wrap;
  },

  startLoadingBtn: function(btn) {
    btn.find('i').addClass(this.selectors.loadingAjaxClass);
  },

  endLoadingBtn: function(btn) {
    btn.find('i').removeClass(this.selectors.loadingAjaxClass);
  },

  showLoadingFull: function() {
    if(!this.data.initTopBar) {
      topbar.config(topbarConfig);
      this.data.initTopBar = true;
    }
    topbar.show();
  },

  hideLoadingFull: function() {
    topbar.hide();
  },

  getPriceHtml: function(price) {
    return theme.Currency.formatMoney(price, theme.moneyFormat);
  },

  handleString: function(str) {
    return str.toLowerCase().replace(/\"/g,'').replace(/\'/g,'').replace(/[\(,\*,\)]/g,'').replace(/  /g,' ').replace(/ /g,'-');
  },

  escapeString: function(str) {
    return str.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
  },

  convertCurrencySilence: function(selector) {
    BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, selector);
  },

  callSnippetAjax: function(snippetName, cb) {
    this.callAjax(theme.rootUrl, 'GET', {view: snippetName}, null, (html) => {
      cb(html);
    });
  },

  loadSnippetAjax: function(snippetName, cb, delay) {
    if(this.data.loadedSnippets.indexOf(snippetName) > -1) {
      cb();
    } else {
      this.callSnippetAjax(snippetName, (html) => {
        this.data.loadedSnippets.push(snippetName);
        if($('.snippet-error', html).length == 0) {
          $('body').append(html);
          setTimeout(() => {
            cb();
          }, (delay) ? delay : 300);
        }
      });
    }
  },

  processSameId: function(htmlStr) {
    var cloneIdElements = htmlStr.match(/data-clone-id=\"(.*?)\"/g);
    if(cloneIdElements != null) {
      $.each(cloneIdElements, (index, value) => {
        var strFind = value.replace(/data-clone-id=/g,'').replace(/"/g,'');
        var newId = 'clone-' + Math.floor(Math.random() * 100);
        var regex = new RegExp( strFind, 'g' );
        htmlStr = htmlStr.replace(regex, newId);
      });
    }
    return htmlStr;
  },

  showPopup: function(id) {
    let timeout = 0;
    const popupClass = id.replace('#','');
    if($('.modal.in:not(.' + popupClass + ')').length > 0) {
      $('.modal.in:not(.' + popupClass + ')').each((index, popupEle) => {
        this.hidePopup('#' + $(popupEle).attr('id'));
      });
      timeout = 500;
    }
    setTimeout(() => {
      $(id).modal('show');
    }, timeout);
  },

  hidePopup: function(id) {
    $(id).modal('hide');
  },

  showNotify: function(msg, type) {
    var notify = $(this.selectors.notify), activeClass = 'active';
    notify.removeClass(this.selectors.notifyClassTypes);
    notify.addClass('alert-' + type);
    notify.html(msg);
    if(notify.hasClass(activeClass)) {
      if(this.data.notifyTimeout) {
        clearTimeout(this.data.notifyTimeout);
      }
      this.hideNotify();
    } else {
      notify.slideDown(this.options.notifyDuration, () => {
        notify.addClass(activeClass);
        this.hideNotify();
      }); 
    }
  },

  hideNotify: function() {
    var notify = $(this.selectors.notify), activeClass = 'active';
    this.data.notifyTimeout = setTimeout(() => {
      notify.slideUp(this.options.notifyDuration, () => {
        notify.removeClass(activeClass);
      });
    }, this.options.notifyTimeout);
  },

  showOverlay: function(suffixEvent) {
    $('body').addClass(this.selectors.showOverlayClass);
    $(this.selectors.overlay).attr('data-event', suffixEvent);
  },
  hideOverlay: function() {
    $('body').removeClass(this.selectors.showOverlayClass);
    $(this.selectors.overlay).removeAttr('data-event');
  },
  hideOverlayWithEvent: function() {
    $(document).trigger(this.options.overlay.hidePrefixEvent + $(this.selectors.overlay).attr('data-event'));
    this.hideOverlay();
  },
  initOverlay: function() {
    $(document).on('click', this.selectors.overlay, () => {
      this.hideOverlayWithEvent();
    });
  },

  isWebsiteBusy: function() {
    return $('body').hasClass('modal-open') || $('body').hasClass('open-search-suggest');
  },

  runLoadingDropdownNavInAjax: function(wrap, type, cb) {
    var parentItemSelector = this.selectors[type].parentItem, dropdownSelector = this.selectors[type].dropdown;
    var sectionId = $(wrap).attr('data-section-id');
    this.callAjax(theme.rootUrl, 'GET', {'view': 'ajax', 'section_id': sectionId}, null, (html) => {
      $(wrap).find(parentItemSelector).each((index, navItemParent) => {
        var itemId = '#' + $(navItemParent).attr('id');
        $(navItemParent).append($(itemId, html).children(dropdownSelector));
      });
      cb();
    });
  },

  openMobileNav: function() {
    $('.mobile-nav').find('.link-list__item__link.active').each((index, linkEle) => {
      var link = $(linkEle);
      link.parents('.link-list__item__dropdown').each((indexDropdown, dropdownEle) => {
        var dropdown = $(dropdownEle);
        dropdown.show();
        dropdown.parent('.link-list__item').addClass('open');
      });
    });
  },

  /* Mobile Navigation */
  initMobileNavigation: function() {
    var openClass = 'open', workingClass = this.selectors.workingClass;
    function showSubmenu(item) {
      if(item.hasClass(workingClass)) {
        return;
      }
      item.addClass(workingClass);
      item.children('.mobile-nav__children').fadeIn(300, () => {
        item.removeClass(workingClass);
      });
    }
    function hideSubmenu(item, cb) {
      if(item.hasClass(workingClass)) {
        return;
      }
      item.addClass(workingClass);
      item.children('.mobile-nav__children').hide();
      item.removeClass(workingClass);
      if(cb) {
        cb();
      }
    }
    $(document).on('click', '.mobile-nav__arrow', (e) => {
      e.preventDefault();
      var arrow = $(e.currentTarget);
      var parent = arrow.parents('.mobile-nav__item').first();
      if(parent.hasClass(workingClass)) {
        return;
      }

      if(!parent.hasClass(openClass)) {
        parent.addClass(openClass);
        showSubmenu(parent);
        parent.siblings('.' + openClass).each((index, parentEle) => {
          var top = arrow.position().top - 60;
          $(parentEle).removeClass(openClass);
          hideSubmenu($(parentEle), () => {
            if(!BT.isInViewport(arrow, window.self)) {
              parent.parents('.bt-sidebar__inner').scrollTop(top);
            }
          });
        });
      } else {
        parent.removeClass(openClass);
        hideSubmenu(parent);
      }
    });
    // this.openMobileNav();
  },

  showDropdown: function(ele) {
    ele.addClass('active');
  },

  hideDropdown: function(ele){
    ele.removeClass('active');
  },

  initDropdown: function() {
    const dropdownSelector = this.selectors.dropdown,
      overlaySelector = this.selectors.overlay,
      hideOverlayEvent = this.options.overlay.hidePrefixEvent + this.options.dropdown.overlaySuffixEvent;
    $(document).on('mouseenter', dropdownSelector.wrap, (e) => {
      if(!this.data.isTouchDevide) {
        this.showDropdown($(e.currentTarget));
      }
    }).on('mouseleave', dropdownSelector.wrap, (e) => {
      if(!this.data.isTouchDevide && !$(e.currentTarget).is(':focus')) {
        this.hideDropdown($(e.currentTarget));
      }
    });
    $(document).on('click', dropdownSelector.trigger, (e) => {
      if(this.data.isTouchDevide) {
        e.preventDefault();
        var parent = $(e.currentTarget).parents(dropdownSelector.wrap).first();
        if(parent.hasClass('active')) {
          this.hideDropdown(parent);
        } else {
          var dataGroup = parent.attr('data-group');
          if(dataGroup != undefined) {
            $(dropdownSelector.wrap + '[data-group="' + dataGroup + '"].active').removeClass('active');
          }
          this.showDropdown(parent);
        }
      }
    });
    $(document).on(hideOverlayEvent, (e) => {
      if($(dropdownSelector.wrap + '.active').length > 0) {
        $(dropdownSelector.wrap + '.active').removeClass('active');
      }
    });
  },

  getInputFloatSelector: function() {
    var floatSelector = this.selectors.floatField;
    return floatSelector + ' input[type="text"],' 
      + floatSelector + ' input[type="password"],'
      + floatSelector + ' input[type="number"],'
      + floatSelector + ' input[type="email"],'
      + floatSelector + ' input[type="tel"]';
  },



  loadCssJsLib: function(libName, cb) {
    if(theme.loadedLibs.indexOf(libName) > -1) {
      if(cb) {
        cb();
      }
    } else {
      if(theme.libs[libName] != undefined) {
        const cssLibs = theme.libs[libName].css, jsLib = theme.libs[libName].js;
        if(cssLibs != undefined && theme.loadedCssLibs.indexOf(libName) == -1) {
          theme.loadedCssLibs.push(libName);
          $.each(cssLibs, (index, fileUrl) => {
            $('<link/>', {
               rel: 'stylesheet',
               type: 'text/css',
               href: 'https:' + fileUrl
            }).appendTo('head');
          });
        }
        if(jsLib != undefined) {
          if(theme.pendingJsLibs[libName] == undefined) {
            theme.pendingJsLibs[libName] = [];
            $.getScript(
              'https:' + jsLib
            ).then(() => {
              theme.loadedLibs.push(libName);
              if(cb) {
                cb();  
              }
              $.each(theme.pendingJsLibs[libName], (index, cbItem) => {
                cbItem();
                delete theme.pendingJsLibs[libName][index];
              });
            });
          } else {
            if(cb) {
              theme.pendingJsLibs[libName].push(cb);
            }
          }
        } else {
          theme.loadedLibs.push(libName);
          if(cb) {
            cb();
          }
        }
      }
    }
  },

  /* Sidebar */
  initSidebar: function() {
    $(document).on(this.options.sidebar.openEvent, this.selectors.sidebar.btn, (e) => {
      e.preventDefault();
      e.stopPropagation();
      const block = $(e.currentTarget).attr('data-target');
      this.showSidebar(block);
    });
    this.initHideNavMobile(300);
  },
  initHideNavMobile: function(duration) {
    var triggerSelector = this.selectors.sidebar.closeBtnCanvas + ',' + this.selectors.sidebar.closeSidebarBtn;
    var hideOverlayEvent = this.options.overlay.hidePrefixEvent + this.options.sidebar.overlaySuffixEvent;
    $(document).on(this.options.sidebar.closeEvent, triggerSelector, (e) => {
      e.preventDefault();
      e.stopPropagation();
      if($('body').hasClass(this.selectors.sidebar.openClass)) {
        this.hideSidebar(duration, $(this.selectors.overlay).attr('data-block'));
      }
    });
    $(document).on(hideOverlayEvent, () => {
      this.hideSidebar(duration, $(this.selectors.overlay).attr('data-block'));
    });
  },
  showSidebar : function(block) {
    if(!$('body').hasClass(this.selectors.sidebar.openClass)) {
      //$('.wrap-all').css({'overflow-x': 'inherit'});
      $('body').trigger('beforeShowSidebar-' + block.replace('#',''));
      const overlaySelector = this.selectors.overlay;
      $(overlaySelector).attr('data-block', block);

      this.showOverlay(this.options.sidebar.overlaySuffixEvent);
      const ownCanvasOpenClass = this.selectors.sidebar.openClass + '--' + $(block).attr('id');
      $('body').addClass(this.selectors.sidebar.openClass + ' ' + ownCanvasOpenClass);
      $(block).addClass('open');
    }
  },
  hideSidebar: function(duration, block) {
    const ownCanvasOpenClass = this.selectors.sidebar.openClass + '--' + $(block).attr('id');
    $('body').removeClass(this.selectors.sidebar.openClass + ' ' + ownCanvasOpenClass);
    this.hideOverlay();
    $(block).removeClass('open');
  },

  initSlickSlider: function(ele, useEffect) {
    this.loadCssJsLib('slider', () => {
      var dataSlider = {};
      $.extend(true, dataSlider, this.options.slider);
      if(ele.attr('data-slider')) {
        try {
          dataSlider = $.extend(true, dataSlider, JSON.parse(ele.attr('data-slider')));
        } catch(e) {
          ele.addClass('failed');
          dataSlider = this.options.slider;
        }
      }
      if(useEffect) {
        ele.off('beforeChange');
        ele.off('afterSlideChange');
        ele.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
          var $slider = slick.$slider;
          var $currentSlide = $slider.find('.slick-current').addClass('animate-out');
        });
        ele.on('afterChange', (event, slick, currentSlide) => {
          var $slider = slick.$slider;
          var $allSlides = $slider.find('.slick-slide').removeClass('animate-out');
        });
      }
      ele.slick(dataSlider);
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      if(isSafari && ele.hasClass('need-refresh')) {
        ele.slick('refresh');
      }
    });
  },
  initSliderEle: function(ele, useEffect) {
    if(this.data.cacheWindowWidth >= this.options.windowScreen.desktop || !ele.hasClass(this.selectors.slider.useTouchMobile)) {
      var parent = ele.parent();
      parent.height(parent.height());
      parent.css({'overflow': 'hidden'});
      try {
        this.preInitSlider(ele);
        this.initSlickSlider(ele, useEffect);
        setTimeout(() => {
          parent.removeAttr('style');
        }, 500);
      } catch(e) {
        parent.removeAttr('style');
      }
    } else {
      this.preInitSlider(ele);
    }
  },
  preInitSlider: function(wrap, includeHideClass) {
    const wrapObj = this.convertStrToObject(wrap);
    var classes = this.selectors.slider.overFloatClasses;
    if(includeHideClass) {
      classes += ' hide';
    }
    wrapObj.find('.' + classes.replace(/ /g,',.')).removeClass(classes);
  },
  triggerResizeSlider: function(ele) {
    if(ele.hasClass(this.selectors.slider.useTouchMobile)) {
      $(window).on(this.data.resizeEventName, () => {
        if(this.data.cacheWindowWidth >= this.options.windowScreen.desktop) {
          if(!ele.hasClass('slick-initialized')) {
            this.initSlickSlider(ele);
          }
        } else {
          if(ele.hasClass('slick-initialized') && ele.hasClass(this.selectors.slider.useTouchMobile)) {
            setTimeout(() => {
              ele.slick('unslick');
            }, 300);
          }
        }
      });
    }
  },

  getSliderSelector: function() {
    return this.selectors.slider.default + ':not(' + this.selectors.waitingData + ')';
  },

  initSlider: function(wrap, wait, useEffect) {
    const sliderSelector = this.getSliderSelector(), touchMobileWrap = 'touch-mobile';
    const wrapObj = this.convertStrToObject(wrap);
    const sliders = wrapObj.find(sliderSelector);
    if(!sliders.length) {
      return;
    }

    if(this.data.cacheWindowWidth >= this.options.windowScreen.desktop || !wrapObj.hasClass(touchMobileWrap)) {
      if(wait) {
        const suffixEvent = 'init_slider_' + this.data.sliderIndex;
        this.data.sliderIndex++;
        this.initScrollingWindowTriggerOnce(wrapObj, suffixEvent,  -170, () => {
          sliders.each((index, sliderEle) => {
            const ele = $(sliderEle);
            this.initSliderEle(ele, useEffect);
            this.triggerResizeSlider(ele);
          });
        });
      } else {
        sliders.each((index, sliderEle) => {
          const ele = $(sliderEle);
          this.initSliderEle(ele, useEffect);
          this.triggerResizeSlider(ele);
        });
      }
    } else {
      this.preInitSlider(wrapObj);
      sliders.each((index, sliderEle) => {
        const ele = $(sliderEle);
        this.triggerResizeSlider(ele);
      });
    }
  },

  destroySlider: function(wrap) {
    var sliders = this.convertStrToObject(wrap).find(this.getSliderSelector());
    if(!sliders.length) {
      return;
    }
    sliders.each((index, sliderEle) => {
      const ele = $(sliderEle);
      if(ele.hasClass('slick-initialized')) {
        ele.slick('unslick');
      }
    });
  },

  initTabsCallback: function() {
    $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
      const windowWidth = this.data.cacheWindowWidth;
      const href = $(e.currentTarget).attr('href');
      const tabContent = $(href);
      const sliderSelector = this.selectors.slider.default + ':not(' + this.selectors.waitingData + ')';
      if(tabContent.find(sliderSelector).length > 0) {
        tabContent.find(sliderSelector).each((index, sliderEle) => {
          const ele = $(sliderEle);
          if(windowWidth >= this.options.windowScreen.desktop) {
            if(ele.hasClass('slick-initialized')) {
              ele.slick('setPosition');
            }
          } else {
            if(!ele.hasClass(this.selectors.slider.useTouchMobile) && ele.hasClass('slick-initialized')) {
              ele.slick('setPosition');
            }
          }
        });
      }
      const parent = $(e.currentTarget).closest('.nav-tabs');
      const handleMobile = parent.siblings('.nav-tabs-mobile');
      if(handleMobile.length > 0) {
        handleMobile.find('select').val(href.replace('#tab_',''));
      }
    });
    $(document).on('change', '.tab-list-handle', (e) => {
      const select = $(e.currentTarget);
      $('a[data-toggle="tab"][href="#tab_' + select.val() + '"]').trigger('click');
    });
  },

  submitCartForm: function(form, btn, cb, cbError) {
    if(form.valid()) {
      /*var progressWrap = btn.siblings('.progress');
      var progressBar = progressWrap.find('.progress-bar');
      if(progressWrap) {
        progressWrap.removeClass('hide');
      }*/
      form.ajaxSubmit({
        url: theme.cartAddUrl,
        type: 'post',
        dataType: 'json',
        error: (xhr, textStatus, errorThrown) => {
          if(xhr.responseJSON.description != undefined && xhr.responseJSON.description != null) {
            this.showNotify(xhr.responseJSON.description, this.options.notifyClassTypes.danger);
          } else if (xhr.responseJSON.message != undefined) {
            this.showNotify(xhr.responseJSON.message, this.options.notifyClassTypes.danger);
            //showNotifyMsg(xhr.responseJSON.message, 'error');
          }
          this.endLoadingBtn(btn);
          btn.removeClass(this.selectors.workingClass);
          //showNotifyMsg(xhr.responseJSON.description, 'error');
          /*if(progressWrap) {
            progressBar.width('0%').text('0%');
            progressWrap.addClass('hide');
          }*/
        },
        uploadProgress: function(event, position, total, percentComplete) {
          /*if(progressWrap) {
            progressBar.width(percentComplete + '%').text(percentComplete + '%');  
          }*/
        },
        success: function(data, textStatus, jqXHR, $form) {
          /*if(progressWrap) {
            progressBar.width('0%').text('0%');
            progressWrap.addClass('hide');
          }*/
          cb(data);
        }
      });
    } else {
      cbError();
    }
  },

  updateFaviconBadge: function(number) {
    if(!theme.favicon.enable || this.data.cacheWindowWidth < 768 || !number) {
      return false;
    }
    if(this.data.favicon == null) {
      this.data.favicon = new Favico({
        animation:'slide',
        position: theme.favicon.pos,
        bgColor : theme.favicon.bkgColor,
        textColor : theme.favicon.textColor,
      });
    }
    number = parseInt(number);
    if(number > 0) {
      this.data.favicon.badge(number);
    } else {
      this.data.favicon.reset();
    }
  },

  updateHeaderCartHtml: function(ignoreCartAction) {
    if((theme.cartAction == 'redirect' || theme.cartAction == 'redirect_checkout' ) && ignoreCartAction == false) {
      return;
    }
    const cartSelector = this.selectors.cart;
    if(theme.libs['header-cart'] != undefined) {
      this.loadCssJsLib('header-cart', () => {
        new Promise((resolve, reject) => {
          this.callAjax(theme.rootUrl, 'GET', {view: 'header_cart'}, null, (response) => {
            const htmlHeaderCart = $(cartSelector.header, response).html(), headerCartSelector = cartSelector.header;
            $(headerCartSelector).each((index, headerCartEle) => {
              $(headerCartEle).html(this.processSameId(htmlHeaderCart));
            });
            const number = $(cartSelector.number, response).html();
            const total = $(cartSelector.total, response).html();
            $(cartSelector.number).html(number);
            $(cartSelector.total).html(total);
            this.updateFaviconBadge(number);
            resolve(cartSelector.header);  
          });
        }).then((wrapper) => {
          if(wrapper != undefined) {
            this.convertCurrencySilence(wrapper + ' span.money');
            $(document).trigger('ajaxCart.afterUpdateHeaderCartHtml');
          }
          this.convertCurrencySilence(cartSelector.total + ' span.money');
          this.resetCartTerms();
          $(document).trigger('ajaxCart.afterCartLoad');
          // Not run below code on cart page
          if (window.Shopify && Shopify.StorefrontExpressButtons != undefined && !$('body').hasClass('template-cart')) {
            Shopify.StorefrontExpressButtons.initialize();
          }
        }, (err) => {
          // console.log(err);
        });
      });  
    }
  },

  generateCartMessage: function(productTitle) {
    return theme.strings.addCartMsg.replace(this.options.productNameHolder, '<strong>' + productTitle + '</strong>');
  },

  updateCartMessage: function(productTitle) {
    $(this.selectors.cartMessage).removeClass('hide').html(this.generateCartMessage(productTitle));
  },

  showPopupCart: function(cartResponse, cb) {
    this.loadSnippetAjax('popup-cart', () => {
      this.loadUpsellInPopup(cartResponse.handle, cartResponse.title);
      this.updateCartMessage(cartResponse.title);
      const selector = this.selectors.cartModal;
      // wrap: '#cartModal',
      //   productImage: '.cart-response__image',
      //   productName: '.cart-response__name',
      //   variantTitle: '.cart-response__meta-variant-title',
      //   variantProp: '.cart-response__meta-propeties',
      //   price: '.cart-response__price',
      //   qty: '.cart-response__qty'
      $(selector.productImage).attr('href', cartResponse.url)
        .attr('title', cartResponse.title)
        .find('img')
        .attr('src', this.resizeImage(cartResponse.image, '360x'))
        .attr('alt', cartResponse.title);
      
      $(selector.productName + ' > a').attr('title', cartResponse.title)
        .attr('href', cartResponse.url)
        .html(cartResponse.product_title);
      
      const variantTitle = $(selector.variantTitle);
      variantTitle.html('');
      if(cartResponse.variant_title != null) {
        $(cartResponse.options_with_values).each((index, option) => {
          variantTitle.append('<span class="cart-response__meta-variant-title w100 db">' + option.name + ': ' + option.value + '</span>');
        });   
      }

      if(cartResponse.properties) {
        var prop = $(selector.variantProp);
        prop.removeClass('hide');
        prop.html('');
        $.each(cartResponse.properties, (index, p) => {
          var pItem = $('<span class="gutter-ele-small-top w100 db cart__meta-text"></span>');
          pItem.append(index + ': ');
          if(p.indexOf('/uploads/') > 0) {
            pItem.append(p.split("/").pop());
          } else {
            pItem.append(p);
          }
          prop.append(pItem);
        });
      } else {
        $(selector.variantProp).addClass('hide');
      }

      $(selector.qty).html(cartResponse.quantity); 
      $(selector.price).html(this.getPriceHtml(cartResponse.price)); 
      $(selector.linePrice).html(this.getPriceHtml(cartResponse.line_price));
      this.resetCartTerms();
      if(theme.enableFreeShipping) {
        this.callAjax(theme.cartJsonUrl, 'GET', null, 'json', (cartObj) => {
          this.convertProgressBar(cartObj.total_price, true);
          BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, selector.wrap + ' span.money');
          this.showPopup(selector.wrap);
          cb();
        });
      } else {
        BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, selector.wrap + ' span.money');
        this.showPopup(selector.wrap);
        cb();
      }
    });
  },

  convertProgressBar: function(currentTotal, force) {
    if((!theme.enableFreeShipping || BtCurrency.rates == undefined || !(useCurrencyConverterPlusEngine && defaultCurrency != shopCurrency) || $('.free-shipping-text').length == 0) && (force == undefined)) {
      return;
    }
    var finalGoal = (useCurrencyConverterPlusEngine && defaultCurrency != shopCurrency && BtCurrency.rates != undefined) ? theme.freeShippingGoal/BtCurrency.rates[shopCurrency] : theme.freeShippingGoal;
    currentTotal = (currentTotal != undefined) ? currentTotal : parseFloat($('.free-shipping-text--data').attr('data-current'));
    var percentNumber;
    if(currentTotal >= finalGoal) {
      $('.free-shipping-text').text(theme.freeShippingGoalText);
      percentNumber = 100;
    } else {
      var remainAmount = finalGoal - currentTotal;
      var remainAmountHtml = '<strong>' + BT.getPriceHtml(remainAmount) + '</strong>';
      $('.free-shipping-text').html(theme.freeShippingProgressText.replace('[remain_amount]', remainAmountHtml));
      percentNumber = Math.floor((currentTotal * 100)/finalGoal);
    }
    $('.cart__free-progress-bar').attr('aria-valuenow',percentNumber).css('width', percentNumber + '%');
    $('.cart__free-progress-bar span').text(percentNumber + '%').css((!rtl ? 'left' : 'right'), percentNumber + '%'); 
  },

  enableCartTerms: function() {
    $(this.selectors.cartTerms.checkbox).prop('checked', false);
    $(this.selectors.cartTerms.checkoutBtn).addClass('disabled');
    $(this.selectors.cartTerms.paymentBtn).addClass('disabled');
  },

  disableCartTerms: function() {
    $(this.selectors.cartTerms.checkbox).prop('checked', true);
    $(this.selectors.cartTerms.checkoutBtn).removeClass('disabled');
    $(this.selectors.cartTerms.paymentBtn).removeClass('disabled');
  },

  resetCartTerms: function() {
    if(this.agreeCartTerms()) {
      this.disableCartTerms();
    } else {
      this.enableCartTerms();
    }
  },

  showCartTermsErrorMsg: function(label) {
    label.addClass('notify-terms');
    if(label.siblings('.alert').length == 0) {
      label.parent().append('<div class="alert alert-danger w100 distance-top-ele" style="margin-bottom:0;display:none;">' + theme.strings.cartTermsErrorMsg + '</div>');  
    }
    label.siblings('.alert').show(300);
  },

  hideCartTermsErrorMsg: function() {
    var label = $(this.selectors.cartTerms.label);
    label.removeClass('notify-terms');
    label.siblings('.alert').hide(300);
  },

  initAgreeCartTems: function(){
    if(!theme.cartTerms) {
      return true;
    }
    const cookieName = this.options.cartTerms.cookieName, selector = this.selectors.cartTerms;
    this.resetCartTerms();
    $(document).on('change', selector.checkbox, (e) => {
      e.preventDefault();
      if($(e.currentTarget).is(':checked')) {
        this.setCookie(cookieName, 1);
        if($(e.currentTarget).hasClass('redirect')) {
          window.location.href = '/checkout';
        } else {
          $(selector.checkbox).not(this).prop('checked', true);
          $(selector.checkoutBtn).removeClass('disabled');
          $(selector.paymentBtn).removeClass('disabled');
          this.hideCartTermsErrorMsg();
        }
      } else {
        this.setCookie(cookieName, null);
        $(selector.checkbox).not(this).prop('checked', false);
        $(selector.checkoutBtn).addClass('disabled');
        $(selector.paymentBtn).addClass('disabled');
      }
    });
    $(document).on('click', '.shopify-payment-button,' + selector.checkoutBtn, (e) => {
      if($(e.currentTarget).hasClass('disabled')) {
        e.preventDefault();
        this.showCartTermsErrorMsg($(e.currentTarget).parent().siblings(selector.wrap).find(selector.label).first());
      } else {
        if($(e.currentTarget).hasClass('checkout-btn--redirect')) {
          window.location.href = theme.rootUrl + 'checkout';
        }
      }
    });
  },

  agreeCartTerms: function() {
    if(!theme.cartTerms) {
      return true;
    }
    var cookieName = this.options.cartTerms.cookieName;
    var cookie = this.getCookie(cookieName);
    if(cookie == undefined || cookie == null || cookie == 'null') {
      return false;
    }
    return true;
  },

  runCartAction: function(cartResponse, cb) {
    if(theme.cartAction == 'redirect') {
      window.location.href = theme.cartUrl;
    } else if (theme.cartAction == 'redirect_checkout') {
      if(this.agreeCartTerms()) {
        window.location.href = '/checkout';
      } else {
        this.updateHeaderCartHtml(true);
        this.loadSnippetAjax('popup-terms', () => {
          if($(this.selectors.cartTerms.popup).length > 0) {
            this.showPopup(this.selectors.cartTerms.popup);
            cb();
          }
        });
      }
    } else if(theme.cartAction == 'popup') {
      this.updateHeaderCartHtml(false);
      this.showPopupCart(cartResponse, cb);
    } else if(theme.cartAction == 'open_cart' && theme.template != 'cart') {
      this.updateHeaderCartHtml(false);
      setTimeout(() => {
        this.showSidebar('#bt-sidebar-cart');
        cb();
      }, 300);
    } else if(theme.cartAction == 'notify_msg') {
      this.updateHeaderCartHtml(false);
      this.showNotify(this.generateCartMessage(cartResponse.title), this.options.notifyClassTypes.success);
      cb();
    } else {
      this.updateHeaderCartHtml(false);
      cb();
    }
  },

  initCartEvent: function () {
    const cartSelector = this.selectors.cart;
    $(document).on('click', cartSelector.addBtn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass(this.selectors.workingClass)) {
        return;
      }
      // Add product to cart
      const form = $(e.currentTarget).parents('form');
      if(!form.find('.variant-id').val()) {
        const pg = form.parents(this.selectors.productGroup.wrap).first();
        pg.find(this.selectors.productGroup.option).each((index, option) => {
          if(!this.getValueFromOptionTag($(option))) {
            this.showMissingOption(pg, $(option));
            return false;
          }
        });
        return;
      }
      btn.addClass(this.selectors.workingClass);
      this.startLoadingBtn(btn);
      this.submitCartForm(form, btn, (response) => {
        this.runCartAction(response, () => {
          this.endLoadingBtn(btn);
          if((theme.cartAction == 'open_cart' || theme.cartAction == 'notify_msg') && btn.parents('.modal').length > 0) {
            this.hidePopup('#' + btn.parents('.modal').first().attr('id'));
          }
        });
        btn.removeClass(this.selectors.workingClass);
      }, function() {
        this.endLoadingBtn(btn);
        btn.removeClass(this.selectors.workingClass);
      });
    });

    $(document).on('click', cartSelector.updateBtn, (e) => {
      e.preventDefault();
      const updateBtn = $(e.currentTarget);
      if(updateBtn.hasClass(this.selectors.workingClass)) {
        return;
      }
      updateBtn.addClass(this.selectors.workingClass);
      var line = updateBtn.attr('data-index');
      var value = updateBtn.attr('data-value');
      var i = updateBtn.find('i');
      i.addClass(this.selectors.loadingAjaxClass);
      if(isNaN(value)) {
        if($(value).length == 0) {
          updateBtn.find('i').removeClass(this.selectors.loadingAjaxClass);
          updateBtn.removeClass(this.selectors.workingClass);
          return;
        }
        // value is selector to an input
        value = $(value).val();
      }
      this.requestUpdateCart(line, value, () => {
        this.updateHeaderCartHtml(true);
      }, () => {
        i.removeClass(this.selectors.loadingAjaxClass);
      });
    });

    $(document).on('change', cartSelector.qtyInput, (e) => {
      var line = $(e.currentTarget).attr('data-line');
      this.showLoadingFull();
      this.requestUpdateCart(line, $(e.currentTarget).val(), () => {
        this.updateHeaderCartHtml(true);
        this.hideLoadingFull();
      }, () => {
        this.hideLoadingFull();
      });
    });

    if(theme.libs['header-cart'] != undefined) {
      $('body').one('beforeShowSidebar-bt-sidebar-cart', (e) => {
        this.updateHeaderCartHtml(false);
      });
    }
  },

  hideSearchFull: function() {
    $(this.selectors.searchFull.wrap).removeClass('open');
    $('body').removeClass('open-search-suggest');
  },

  showSearchSuggestionContent: function() {
    this.startLoadingSuggestedProducts();
    $(this.selectors.searchFull.wrap).addClass('open');
    $('body').addClass('open-search-suggest');
    this.showOverlay(this.options.searchFull.suffixEvent);
  },

  renderSearchFullContent: function(html) {
    const selector = this.selectors.searchFull;
    this.data.searchSuggestionCurrentAjaxRequest = null;
    $(selector.loading).removeClass(this.selectors.loadingAjaxClass);
    $(selector.content).addClass(selector.loadedClass);
    const resultWrap = $(selector.content);
    resultWrap.html(html);
    $(selector.suggestProducts).hide();
    this.convertCurrencySilence(resultWrap.find('span.money'));
    this.initDealCountdown(resultWrap);
    this.reLoadReview(resultWrap);
    this.popularAddedWishlistItems(resultWrap);
  },

  startLoadingSuggestedProducts: function() {
    if(this.data.searchSuggestionLoadSuggestedProducts || !$(this.selectors.searchFull.suggestProducts).length) {
        return;
      }
    this.data.searchSuggestionLoadSuggestedProducts = true;
    this.callSnippetAjax('search-full-suggest', (html) => {
      $(this.selectors.searchFull.suggestProducts).html(html);
      });
  },

  initSearchSuggestion: function () {
    const selector = this.selectors.searchFull, workingClass = 'working', snippetName = 'search-full';
    let resetHeight = false, tempTerm = undefined, loadSuggestedProducts = false;
    $(document).on('click', selector.trigger, (e, term, hideSuggestProducts) => {
      e.preventDefault();
      if(term != undefined) {
        tempTerm = term;
      }
      const btn = $(e.currentTarget);
      if(btn.hasClass(workingClass)) {
        return;
      }
      btn.addClass(workingClass);
      this.showSearchSuggestionContent();
      btn.removeClass(workingClass);
      if(tempTerm != undefined) {
        $(selector.input).val(tempTerm);
        $(selector.input).trigger('change');
        tempTerm = undefined;
      }
      if(term == undefined) {
        $(selector.input).focus();  
      }
    });
    $(document).on('click', selector.close, (e) => {
      e.preventDefault();
      this.hideSearchFull();
      this.hideOverlay();
    });
    if(!theme.searchSuggest.enable) {
      return;
    }
    const loadedClass = 'loaded';
    let needResetLoaded = false;
    let dataSearch = {options:{prefix:'last'}};
    $(document).on('keyup change', selector.input, $.throttle(500, (evt) => {
      const input = $(evt.currentTarget), term = input.val(); 
      if (term.length >= 3 && term != input.attr('data-term')) {
        if (this.data.searchSuggestionCurrentAjaxRequest != null) {
          this.data.searchSuggestionCurrentAjaxRequest.abort();
        }
        const searchURL = theme.searchUrl + '?view=suggest&q=' + term + '&type=product';
        $(selector.loading).addClass(this.selectors.loadingAjaxClass);
        input.attr('data-term', term);
        needResetLoaded = true;
        this.data.searchSuggestionCurrentAjaxRequest = this.callAjax(searchURL, 'GET', dataSearch, null, (html) => {
          $(selector.tabList).removeClass('hide');
          $(selector.content).removeClass('hide');
          $(selector.tabContent + ':not(.active)').removeClass(loadedClass);
          needResetLoaded = false;
          this.renderSearchFullContent(html);
          $(window).trigger('renderedSearchFullContent', [term]);
        });
      }
    }));

    let typingTimer;
    $(document).on('keyup', selector.inputSync, (evt) => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(() => {
        const input = $(evt.currentTarget), term = input.val();
        if (term.length >= 3) {
          $(selector.trigger).trigger('click', [term, true]);
        }
        $(selector.inputSync).siblings('button').find('i').removeClass(this.selectors.loadingAjaxClass);
      }, 1500);
    });

    //on keydown, clear the countdown 
    $(document).on('keydown', selector.inputSync, $.throttle(100, () => {
      clearTimeout(typingTimer);
      $(selector.inputSync).siblings('button').find('i').addClass(this.selectors.loadingAjaxClass);
    }));

    $(window).on('renderedSearchFullContent', (e, term) => {
      $(selector.inputSync).attr('term', term);
      $(selector.inputSync).siblings('button').find('i').removeClass(this.selectors.loadingAjaxClass);
    });
    const hideOverlayEvent = this.options.overlay.hidePrefixEvent + this.options.searchFull.suffixEvent;
    $(document).on(hideOverlayEvent, (e) => {
      this.hideSearchFull();
    });
  },

  loadUpsell: function(wrap) {
    if(typeof wrap == 'undefined' || wrap.length == 0) {
      return;
    }
    const selector = this.selectors.upsell;
    const productHandle = wrap.attr('data-handle');
    const list = wrap.find(selector.list);
    if(list.hasClass('slick-initialized')) {
      list.slick('unslick');
    }
    list.html('');
    list.siblings(this.selectors.loadingNotFull).show();
    wrap.show();
    const limit = upsellRandom ? 100 : parseInt(wrap.attr('data-limit'));
    const realLimit = parseInt(wrap.attr('data-limit'));
    this.callAjax(theme.rootUrl + 'products/' + productHandle, 'GET', {view:'upsell_tags'}, null, (responseTags) => {
      new Promise((resolve, reject) => {
        let upsellTags = $.parseJSON(responseTags.replace('<!-- BEGIN template -->','').replace('<!-- product.upsell_tags -->','').replace('<!-- END template -->','')), upsellList = [], upsellIds = [], index = 0;
        const tagsLength = upsellTags.length;
        if(tagsLength == 0) {
          resolve([]);
        }
        const view = wrap.attr('data-slider') ? 'upsell_slider' : 'upsell';
        $(upsellTags).each((indexTag, tag) => {
          this.callAjax(theme.collectionAllUrl + '/' + tag, 'GET', {view:view}, null, (responseUpsell) => {
            $('.product-item', responseUpsell).each((indexItem, pItemEle) => {
              const pItem = $(pItemEle);
              if(upsellIds.indexOf(pItem.attr('data-id')) < 0 && pItem.attr('data-handle') != productHandle && index < limit) {
                upsellList.push(pItem.html());
                upsellIds.push(pItem.attr('data-id'));
                index++;
              }
            });
            
            if(indexTag == tagsLength - 1) {
              if(upsellRandom) {
                upsellList = this.shuffleArray(upsellList);
              }
              resolve(upsellList);
            }
          });  
        });
      }).then((upsellList) => {
        list.siblings(this.selectors.loadingNotFull).hide();
        if(upsellList.length > 0) {
          let index = 0;
          $(upsellList).each((i, value) => {
            if(index < realLimit) {
              list.append(value);  
            }
            index++;
          });
          this.convertCurrencySilence(list.find('span.money'));
          this.initSlider(wrap, false, false);
          this.popularAddedWishlistItems(wrap);
        } else {
          wrap.hide();
        }
      }, (e) => {
        // console.log(e);
      });
    });
  },

  loadUpsellInPopup: function(productHandle, productTitle) {
    const upsellEle = $(this.selectors.cartModal.wrap + ' ' + this.selectors.upsell.wrap);
    if(typeof upsellEle == 'undefined' || upsellEle.length == 0) {
      return;
    }
    upsellEle.attr('data-handle', productHandle);
    upsellEle.find('.upsell-title').html(theme.strings.upsellTitle.replace(this.options.productNameHolder, '<strong>' + productTitle + '</strong>'));
    this.loadUpsell(upsellEle);
  },


  gotoSliderIndex: function(slider, index, ignoreAnimate = true) {
    try {
      slider.slick('slickGoTo', index, ignoreAnimate);
    } catch(e) {
      setTimeout(() => {
        slider.slick('slickGoTo', index, ignoreAnimate);
      }, 1000);
    }
  },

  getUnitPriceHtml: function(pg, variant) {
    if(variant.unit_price_measurement != undefined) {
      let html = '<span class="w100 gutter-ele' + (!pg.hasClass('product-single') ? '-small' : '') + '-top product-price__unit db">';
      html += this.getPriceHtml(variant.unit_price) + '<span class="product-price__unit__separator">/</span><span class="product-price__unit__base">'
      + (variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value : '') + variant.unit_price_measurement.reference_unit + '</span>';
      html += '</span>';
      return html;
    }
    return '';
  },

  getPriceTagHtml: function(price, compareAtPrice) {
    let priceHtml = '';
    if(compareAtPrice > price) {
      priceHtml += '<span class="product-price__price">' + this.getPriceHtml(price) + '</span>';
      priceHtml += '<s class="product-price__price product-price__sale">' + this.getPriceHtml(compareAtPrice) + '</s>';
    } else {
      priceHtml += '<span class="product-price__price">' + this.getPriceHtml(price) + '</span>';
    }
    return priceHtml;
  },

  getVariantPriceHtml: function(pg, variant) {
    return this.getPriceTagHtml(variant.price, variant.compare_at_price) + this.getUnitPriceHtml(pg, variant);
  },

  syncVariantUrl: function(pg, newVariant) {
    if(pg.find(this.selectors.productGroup.syncUrl).length > 0) {
      var syncUrl = pg.find(this.selectors.productGroup.syncUrl).attr('href').split('?')[0];
      var newSyncUrl = syncUrl + '?variant=' + newVariant.id;
      pg.find(this.selectors.productGroup.syncUrl).attr('href', newSyncUrl);
    }
  },

  showMissingOption: function(pg, option) {
    const selector = this.selectors.productGroup;
    option.addClass(selector.requiredOptionsClass);
    if(!option.hasClass('swatch')) {
      option.find(selector.optionValue).val('');
    } else if(option.hasClass(selector.swatchColorClass)) {
      if(option.next(selector.optionSub).length > 0) {
        option.next(selector.optionSub).addClass('hide');
      }
    }
    pg.find(selector.variantId).val('');
    pg.find(selector.variantId).trigger('change');
    this.updateOriginalPriceHtml(pg);
    this.updateCartBtn(pg);
  },

  removeMissingOptionBox: function(option) {
    const selector = this.selectors.productGroup;
    option.removeClass(selector.requiredOptionsClass);
  },
  
  getValueFromOptionTag: function(option) {
    if(option.hasClass('swatch')) {
      return option.find(this.selectors.productGroup.selectedSelector).first().attr('data-value');
    } else {
      return option.find('select').val();
    }
  },
  
  findAvailableOptionsBySelect: function(select, jsonData) {
    let availableValues = [], instockValues = [], validItems = [];
    const length = select.length;
    $.each(jsonData, (indexLoop, item) => {
      if(availableValues.indexOf(item.options[length]) == -1) {
        let valid = true;
        $.each(select, (indexLoopSelect, value) => {
          if(item.options[indexLoopSelect] != value) {
            valid = false;
            return;
          }
        });
        if(valid) {
          availableValues.push(item.options[length]);
          if(item.available && instockValues.indexOf(item.options[length]) == -1) {
            instockValues.push(item.options[length])
          }
          validItems.push(item)
        }
      }
    });
    return {
      availableValues: availableValues,
      outstockValues: availableValues.filter(x => !instockValues.includes(x)),
      validItems: validItems
    };
  },

  populateOptionSelectByVariant: function(pg, variant, ignoreMainImage = false) {
    const selector = this.selectors.productGroup;
    pg.find(selector.option).each((indexLoop, optionEle) => {
      const currentOption = $(optionEle);
      const isSwatchTag = currentOption.hasClass('swatch');
      if(isSwatchTag) {
        currentOption.find(selector.optionValue + selector.selectedSelector).removeClass(selector.selectedClass);
        this.updateColorText(null, variant.options[indexLoop], currentOption);
      } else {
        currentOption.find(selector.optionValue + ' option').removeAttr('selected');
        currentOption.find(selector.optionValue).first().val(variant.options[indexLoop]);
      }
      if(!currentOption.hasClass('last')) {
        if(isSwatchTag) {
          currentOption.find(selector.optionValue + '[data-value="' + this.escapeString(variant.options[indexLoop]) + '"]').addClass(selector.selectedClass);
        } 
      } else {
        if(isSwatchTag) {
          currentOption.find(selector.optionValue + '[data-value="' + this.escapeString(variant.options[indexLoop]) + '"]').trigger('click', [ignoreMainImage]);
        } else {
          currentOption.find(selector.optionValue).first().trigger('change', [ignoreMainImage]);
        }
      }
    });
  },

  updateOriginalPriceHtml: function(pg) {
    if(pg.attr('data-price') != undefined) {
      const price = parseInt(pg.attr('data-price'));
      const comparePrice = parseInt(pg.attr('data-compare-at-price') || 0);
      pg.find(this.selectors.productGroup.price).html(this.getPriceTagHtml(price, comparePrice));
      this.updateDealLabel(pg, price, comparePrice);
      this.convertCurrencySilence(pg.find('span.money'));
    }
  },

  updateCartBtn: function(pg, variant) {
    const selector = this.selectors.productGroup;
    const cartBtn = pg.find(selector.cartBtn);
    let finalAvailable, cartText;
    if(variant) {
      finalAvailable = variant.available;
    } else {
      const available = pg.attr('data-available');
      if(available) {
        finalAvailable = available;
      }
    }   

    if(finalAvailable) {
      if(theme.preOrder && variant && variant.inventory_policy == 'continue' && variant.inventory_quantity <= 0) {
        cartText = theme.strings.preOrderText;
      } else {
        cartText = theme.strings.addToCart;
      }
      cartBtn.removeAttr('disabled');
      cartBtn.removeClass('soldout');
      cartBtn.attr('title', cartText);
      cartBtn.find('span.button__cart-text-js').text(cartText);
    } else {
      cartBtn.attr('disabled','disabled');
      cartBtn.addClass('soldout');
      cartBtn.attr('title', theme.strings.soldOut);
      cartBtn.find('span.button__cart-text-js').text(theme.strings.soldOut);
    }
  },

  updateDealLabel: function(pg, price, comparePrice) {
    const selector = this.selectors.productGroup;
    if(pg.find(selector.labelDeal).length > 0) {
      const label = pg.find(selector.labelDeal);
      if(comparePrice && comparePrice > price) {
        label.removeClass('hide');
        if(label.find(selector.labelPercent).length > 0) {
          var percentNumber = Math.floor(((comparePrice - price)/comparePrice)*100);
          label.find(selector.labelPercent).html(percentNumber + '%');
        }
      } else {
        label.addClass('hide');
      }
    }
  },

  updateColorText: function(optionValue, text, option) {
    const selector = this.selectors.productGroup;
    if((optionValue && optionValue.hasClass(selector.swatchItemColorClass)) || (option && option.hasClass(selector.swatchColorClass))) {
      const finalOption = option || optionValue.parents(selector.option).first();
      finalOption.next(selector.optionSub).removeClass('hide').children(selector.optionSubValue).text(text || optionValue.text());
    }
  },

  resetSelectedVariantRows: function(pg) {
    const selector = this.selectors.productGroup;
    pg.find(selector.option).each((indexLoop, optionEle) => {
      const currentOption = $(optionEle);
      this.removeMissingOptionBox(currentOption);
      const isSwatchTag = currentOption.hasClass('swatch');
      const valueSelector = isSwatchTag ? selector.optionValue : (selector.optionValue + ' option:not(.pg__option__value--empty)');
      currentOption.find(valueSelector).removeClass(selector.selectedClass).removeClass(selector.hideClass);
      if(!isSwatchTag) {
        currentOption.find(valueSelector).removeAttr('selected');
        currentOption.find(selector.optionValue).val('');
      }
      pg.find(selector.variantId).val('');
    });
  },

  resetVariantsRow: function(pg, jsonData, ignoreMissingBox = false) {
    const selector = this.selectors.productGroup;
    let currentSelect = [], isMissing = false, validItems = [];
    
    pg.find(selector.option).each((indexLoop, optionEle) => {
      const currentOption = $(optionEle);
      if(!ignoreMissingBox) {
        this.removeMissingOptionBox(currentOption);  
      }
      
      const currentIndex = parseInt(currentOption.attr('data-index'));
      const optionValues = this.findAvailableOptionsBySelect(currentSelect, jsonData);
      const isSwatchTag = currentOption.hasClass('swatch');
      const valueSelector = isSwatchTag ? selector.optionValue : (selector.optionValue + ' option:not(.pg__option__value--empty)');
      currentOption.find(valueSelector + selector.hideSelector).removeClass(selector.hideClass);
      currentOption.find(valueSelector).each((indexValue, optionValueEle) => {
        const currentOptionValue = $(optionValueEle);
        let value;
        if(isSwatchTag) {
          value = currentOptionValue.attr('data-value');
          if(optionValues.availableValues.indexOf(value) == -1) {
            currentOptionValue.addClass(selector.hideClass);
            if(currentOptionValue.hasClass(selector.selectedClass)) {
              currentOptionValue.removeClass(selector.selectedClass);
            }
          }
          if(optionValues.outstockValues.indexOf(value) > -1) {
            currentOptionValue.addClass(selector.swatchOutStock);
          } else {
            currentOptionValue.removeClass(selector.swatchOutStock);
          }  
        } else {
          value = currentOptionValue.attr('value');
          if(optionValues.availableValues.indexOf(value) == -1) {
            currentOptionValue.addClass(selector.hideClass);
            currentOptionValue.removeAttr('selected');
          }
          if(optionValues.outstockValues.indexOf(value) > -1) {
            currentOptionValue.attr('disabled', 'disabled');
          } else {
            currentOptionValue.removeAttr('disabled');
          }
        }
      });
      if(!isSwatchTag) {
        const selectorValue = currentOption.find(selector.optionValue).first().val();
        if(selectorValue) {
          if(currentOption.find(valueSelector + '[value="' + this.escapeString(selectorValue) + '"]').first().hasClass('hide')) {
            currentOption.find(selector.optionValue).val('');
          }  
        }
      }
      if((isSwatchTag && currentOption.find(selector.selectedSelector).length == 0) || (!isSwatchTag && currentOption.find(selector.optionValue).first().val() == '')) {
        if(!ignoreMissingBox) {
          this.showMissingOption(pg, currentOption);  
        }
        isMissing = true;
        return false;
      }
      currentSelect.push(this.getValueFromOptionTag(currentOption));
      if(currentOption.hasClass('last')) {
        validItems = optionValues.validItems;
      }
    });
    return {currentSelect: currentSelect, isMissing: isMissing, validItems: validItems};
  },

  initProductGroup: function() {
    const selector = this.selectors.productGroup, options = this.options.productGroup;
    // Init small images slider
    // this.initProductThumbsSlider();
    // this.initProductMainSliderAndZoom();
    
    $(document).on('click change', selector.optionValue, (e, ignoreMainImage) => {
      e.preventDefault();
      const btn = $(e.currentTarget), pg = btn.parents(selector.wrap).first(), productHandle = pg.attr('data-product-handle');
      if(btn.hasClass('disabled') 
        || (btn.hasClass('selected') && this.data.productGroup[productHandle] != undefined) 
        || (e.type == 'click' && e.currentTarget.nodeName == 'SELECT')) {
        return;
      }
      new Promise((resolve, reject) => {
        this.data.updatingProductOptions = true;
        if(this.data.productGroup[productHandle] == undefined) {
          // Load product data
          pg.addClass(selector.loadingClass);
          this.callAjax(theme.rootUrl + 'products/' + productHandle, 'GET', {view: 'tjson'}, null, (response) => {
            this.data.productGroup[productHandle] = $.parseJSON(response.replace('<!-- BEGIN template -->','').replace('<!-- product.tjson -->','').replace('<!-- END template -->',''));
            pg.removeClass(selector.loadingClass);
            resolve(btn.attr('data-variant-id'));
          });
        } else {
          resolve(btn.attr('data-variant-id'));
        }
      }).then((variantId) => {
        if(e.currentTarget.nodeName != 'SELECT') {
          btn.siblings(selector.selectedSelector).removeClass(selector.selectedClass);
          btn.addClass(selector.selectedClass);
          this.updateColorText(btn);
        }
        let newVariant;
        if(variantId == undefined) {
          // Create current select
          const resetFinal = this.resetVariantsRow(pg, this.data.productGroup[productHandle]);
          if(resetFinal.isMissing == false) {
            const lastOptionValue = resetFinal.currentSelect[resetFinal.currentSelect.length - 1];
            $.each(resetFinal.validItems, (indexItem, item) => {
              const lastOptionValueItem = item.options[item.options.length - 1];
              if(lastOptionValue == lastOptionValueItem) {
                newVariant = item;
                return false;
              }
            });
            this.loadCssJsLib('product-global', () => {
              this.updateNewVariant(pg, newVariant, (ignoreMainImage == undefined) ? true : !ignoreMainImage);
              setTimeout(() => {
                this.data.updatingProductOptions = false;
              }, 300);
            });
          } else {
            if(btn.hasClass('color-value')) {
              this.loadCssJsLib('product-global', () => {
                // Update the image by color
                const colorValue = btn.attr('data-value') || btn.val();
                if(colorValue) {
                  const currentOption = btn.closest(selector.option);
                  const colorIndex = currentOption.attr('data-index');
                  $.each(this.data.productGroup[productHandle], (indexLoop, item) => {
                    if(item.options[colorIndex] == colorValue) {
                      this.updateMainThumbnail(pg, item.featured_media.src, item.featured_media.id)
                      return false;
                    }
                  });  
                } 
              });
            }
            this.data.updatingProductOptions = false;
          }
        } else {
          var variant = this.data.productGroup[productHandle][variantId];
          this.loadCssJsLib('product-global', () => {
            this.removeMissingOptionBox(btn.closest(selector.option));
            if(variant.options.length == 1) {
              this.updateNewVariant(pg, variant, (ignoreMainImage == undefined) ? true : !ignoreMainImage);
            } else {
              if(btn.hasClass('swatch__item')) {
                btn.siblings('.selected').removeClass('selected');
                btn.addClass('selected');
              }
              pg.find(selector.price).html(this.getVariantPriceHtml(pg, variant));
              this.convertCurrencySilence(pg.find('span.money'));
              this.changeMainImage(pg, variant.featured_media.src);
              this.syncVariantUrl(pg, variant);
            }
            setTimeout(() => {
              this.data.updatingProductOptions = false;
            }, 300);
          });
        }
        
      }, (err) => {
        setTimeout(() => {
          this.data.updatingProductOptions = false;
        }, 300);
      });
    });
  },

  initQtyBox: function() {
    const selector = this.selectors.qtyBox;
    $(document).on('click', selector.ctrlBtn, $.throttle( 250, (e) => {
      e.preventDefault();
      let input = $(e.currentTarget).siblings('input').first();
      const value = parseInt(input.val());
      if($(e.currentTarget).hasClass(selector.decreaseBtnClass)) {
        if(value > 1) {
          input.val(value - 1);
          if(input.hasClass(selector.inputSyncClass)) {
            input.trigger('change');
          }
        }
      } else {
        input.val(value + 1);
        if(input.hasClass(selector.inputSyncClass)) {
          input.trigger('change');
        }
      }
    }));
  },

  runCountDown: function (ele, timeValue, pattern) {
    const tplHour = (ele.attr('data-tpl-hour') != undefined) ? ($(ele.attr('data-tpl-hour')).html()) : theme.strings.countdownTplHour;
    const tplDay = (ele.attr('data-tpl-day') != undefined) ? ($(ele.attr('data-tpl-day')).html()) : theme.strings.countdownTplDay;
    const tplWeek = (ele.attr('data-tpl-week') != undefined) ? ($(ele.attr('data-tpl-week')).html()) : theme.strings.countdownTplWeek;
    const productId = ele.data('product-id');
    const cookieReverseName = 'countdown_reverse_' + productId;

    ele.countdown(timeValue)
    .on('update.countdown', (event) => {
      let format = tplHour;
      if(event.offset.totalDays > 0) {
        format = tplDay;
      }
      if(event.offset.weeks > 0) {
        format = tplWeek;
      }
      ele.html(event.strftime(format));
      if(pattern == 2) {
        this.setCookie(cookieReverseName, event.timeStamp);
      }
    })
    .on('finish.countdown', (event) => {
      const extend = parseInt(ele.attr('data-extend'));
      if(pattern == 1 && extend != undefined && Number.isInteger(extend) && extend > 0) {
        const cookieExtendName = 'countdown_extend_' + productId;
        const date = new Date();
        const cookieExtendValue = this.getCookie(cookieExtendName);
        if(cookieExtendValue == undefined) {
          const times = date.getTime() + extend*86400*1000;
          date.setTime(times);
          this.setCookie(cookieExtendName, times, null);
        } else {
          date.setTime(cookieExtendValue);
        }
        timeValue = date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
          + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();
        this.runCountDown(ele, timeValue, 1);
      } else {
        ele.html(theme.strings.countdownExpiredMsg);
        // .parent().addClass('disabled');
        // $(this).parent().addClass('hide');
      }
    });
  },

  initReverseCountdown: function(ele, reverse, productId) {
    const cookieName = 'countdown_reverse_' + productId, cookieCountdown = this.getCookie(cookieName);
    let times;
    if(cookieCountdown == undefined || cookieCountdown == NaN || cookieCountdown == 'NaN' || cookieCountdown == 'null' || cookieCountdown == null) {
      var timesText = reverse.split(':');
      if(timesText.length == 4) {
        var days = parseInt(timesText[0]);
        var hours = parseInt(timesText[1]);
        var minutes = parseInt(timesText[2]);
        var seconds = parseInt(timesText[3]);
        if(hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59 && seconds >= 0 && seconds <= 59) {
          var date = new Date();
          times = date.getTime() + (days*86400 + hours*3600 + minutes*60 + seconds)*1000;
        }
      }
      this.setCookie(cookieName, times, null);
    } else {
      times = parseInt(cookieCountdown);
    }
    if(times != undefined) {
      var currentDate = new Date();
      var currentTime = currentDate.getTime();
      if(times <= currentTime - 30*60) {
        times = null;
        var timesText = reverse.split(':');
        if(timesText.length == 4) {
          var days = parseInt(timesText[0]);
          var hours = parseInt(timesText[1]);
          var minutes = parseInt(timesText[2]);
          var seconds = parseInt(timesText[3]);
          if(hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59 && seconds >= 0 && seconds <= 59) {
            times = currentTime + (days*86400 + hours*3600 + minutes*60 + seconds)*1000;
          }
        }
        this.setCookie(cookieName, times, null);
      }
      if(times) {
        currentDate.setTime(times);
        const timeValue = currentDate.getFullYear() + '/' + (currentDate.getMonth() + 1) + '/' + currentDate.getDate()
          + ' ' + currentDate.getHours() + ':' + currentDate.getMinutes() + ':' + currentDate.getSeconds();
        this.runCountDown(ele, timeValue, 2);
      }
    }
  },

  initDealCountdown: function(wrap) {
    const wrapObj = this.convertStrToObject(wrap);
    if(wrapObj.find(this.selectors.productGroup.countdown).length > 0) {
      wrapObj.find(this.selectors.productGroup.countdown).each((index, countdownEle) => {
        let countdown = $(countdownEle);
        const dataDeal = countdown.attr('data-timer');
        const pattern1 = /^\d{4}\/\d{2}\/\d{2} \d{2}:\d{2}:\d{2}$/;
        const pattern2 = /^\d{1,2}:\d{2}:\d{2}:\d{2}$/;

        if(dataDeal != undefined && dataDeal != '') {
          if(pattern1.test(dataDeal) == true) {
            this.runCountDown(countdown, dataDeal, 1);  
          } else if(pattern2.test(dataDeal)) {
            const productId = countdown.data('product-id');
            this.initReverseCountdown(countdown, dataDeal, productId);
          }
        }
      });
    }
  },

  destroyDealCountdown: function(wrap) {
    const wrapObj = this.convertStrToObject(wrap);
    if(wrapObj.find(this.selectors.productGroup.countdown).length > 0) {
      wrapObj.find(this.selectors.productGroup.countdown).each((index, countdown) => {
        $(countdown).countdown("stop");
      });
    }
  },

  runReLoadReview: function (wrap, includeForm) {
    if(!theme.review.enable) {
      return;
    }
    try {
    if(theme.review.app == 'product_review') {
      if(typeof SPR != 'undefined' && typeof SPR.$ != 'undefined') {
          if(!includeForm) {
        return SPR.initDomEls(), SPR.loadBadges();
          } else {
            SPR.registerCallbacks();
            SPR.initRatingHandler();
            SPR.initDomEls();
            SPR.loadProducts();
            SPR.loadBadges();
      }
        }
    } else if(theme.review.app == 'yotpo') {
      var api = new Yotpo.API(yotpo);
      api.refreshWidgets();
      }
    } catch(e) {
    }
  },
  reLoadReview: function (wrap) {
    this.runReLoadReview(wrap, false);
  },

  runProgressBar: function(progressBar) {
    if(progressBar.length > 0) {
      progressBar.width(progressBar.data('width') + '%');
    }
  },

  // Quick view popup
  initQuickView: function() {
    const qvPopupSelector = this.selectors.qvPopup, qvPopup = $(qvPopupSelector), workingClass = this.selectors.workingClass;
    $(document).on('click', this.selectors.qvBtn, (e) => {
      e.preventDefault();
      let btn = $(e.currentTarget);
      if(btn.hasClass(workingClass)) {
        return;
      }
      btn.addClass(workingClass);
      const url = btn.attr('href');
      this.startLoadingBtn(btn);
      this.loadCssJsLib('quickViewPopup');
        
      this.callAjax(url, 'GET', {view: 'quick_view'}, null, (html) => {
        var jsonScript = $('.product-single-json', html);
        if(jsonScript.length > 0) {
          this.data.productGroup[jsonScript.attr('data-handle')] = $.parseJSON(jsonScript.html());
          this.addProductRecentView(jsonScript.attr('data-id'));
        }
        if($('.product-single-countdown-template').length == 0) {
          $('body').append($('.product-single-countdown-template', html));
        }
        var qvContentEle = qvPopup.find('.product-section-content');
        qvContentEle.html(this.stripScripts($('.section-product-main', html).html()));
        if($('.model-json', html).length > 0) {
          qvContentEle.append($('.model-json', html));
        }
        if(qvContentEle.find('.reset-variant-rows').length > 0) {
          this.resetVariantsRow(qvContentEle.find('.reset-variant-rows').first(), this.data.productGroup[jsonScript.attr('data-handle')], true);
        }
        this.showPopup(qvPopupSelector);
        this.convertCurrencySilence(qvPopupSelector + ' span.money');
        this.endLoadingBtn(btn);
        this.rteWrap(qvPopupSelector + ' .rte');
        btn.removeClass(workingClass);
        this.reLoadReview(qvPopupSelector);
        this.runProgressBar($(qvPopupSelector + ' .progress-bar'));
        this.popularAddedWishlistItems(qvPopupSelector);
      });
    });
    $(document).on('show.bs.modal',qvPopupSelector, () => {
      this.loadCssJsLib('product-global', () => {
        this.init3dModel(qvPopupSelector, qvPopup.find('.model-json').attr('id').replace('ModelJson-',''));
        setTimeout(() => {
          this.initProductThumbsSlider(qvPopup);
          this.initProductMainSliderAndZoom(qvPopup, 0, 0);
        }, 300);
      });
      this.initDealCountdown(qvPopup);
    });
    $(document).on('hidden.bs.modal',qvPopupSelector, () => {
      this.destroyProductMainSliderAndZoom(qvPopup);
      this.destroyProductThumbsSlider(qvPopup);
      this.destroyDealCountdown(qvPopup);
    });
  },

  initSelectOption: function() {
    const selectOptionPopupSelector = this.selectors.selectOptionPopup, workingClass = this.selectors.workingClass;
    $(document).on('click', this.selectors.selectOptionBtn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass(workingClass)) {
        return;
      }
      //btn.addClass(workingClass);
      const url = btn.attr('href');
      this.startLoadingBtn(btn);
      this.loadSnippetAjax('popup-select-option', () => {
        this.callAjax(url, 'GET', {view: 'select_option'}, null, (html) => {
          var jsonScript = $('.product-single-json', html);
          if(jsonScript.length > 0) {
            this.data.productGroup[jsonScript.attr('data-handle')] = $.parseJSON(jsonScript.html());
          }
          $(selectOptionPopupSelector).find('.product-section-content').html(this.stripScripts(html));
          this.convertCurrencySilence(selectOptionPopupSelector + ' span.money');
          this.endLoadingBtn(btn);
          this.showPopup(selectOptionPopupSelector);
          btn.removeClass(workingClass);
        });
      });
    });
  },

  // Comparison popup
  getCookieItemsValue: function(returnArr, cookieName) {
    if(typeof this.data.cookieArray[cookieName] == 'undefined') {
      const handleStr = this.getCookie(cookieName);
      if(handleStr == undefined || handleStr == '') {
        this.data.cookieArray[cookieName] = [];
      } else {
        this.data.cookieArray[cookieName] = handleStr.split(',');
      }
    }
    if(returnArr) {
      return this.data.cookieArray[cookieName];
    }
    return this.data.cookieArray[cookieName].join(',');
  },

  isProductExistInCookie: function(productId, cookieName) {
    const items = this.getCookieItemsValue(true, cookieName);
    return items.indexOf(productId) >= 0;
  },

  addProductToCookie: function(productId, cookieName) {
    let items = this.getCookieItemsValue(true, cookieName);
    if(items.indexOf(productId) < 0) {
      items.push(productId);
      this.data.cookieArray[cookieName] = items;
      this.setCookie(cookieName, items.join(','), null);
    }
  },
  
  removeProductFromCookie: function(productId, cookieName) {
    if(this.data.cookieArray[cookieName] != undefined && this.data.cookieArray[cookieName].indexOf(productId) >= 0) {
      this.data.cookieArray[cookieName].splice(this.data.cookieArray[cookieName].indexOf(productId), 1);
      this.setCookie(cookieName, this.data.cookieArray[cookieName].join(','), null);
    }
  },

  getQueryByIds: function(ids) {
    var newIds = [];
    $.each(ids, (index, id) => {
      newIds.push('id:' + id);
    });
    return newIds.join(' OR ');
  },
  loadCompare: function(cb) { 
    this.loadCssJsLib('quickViewPopup');
    this.callAjax(theme.searchUrl, 'GET', {view: 'compare', q: this.getQueryByIds(this.getCookieItemsValue(true, this.options.compare.cookieName)), type: 'product'}, null, (html) => {
      this.loadSnippetAjax('popup-compare', () => {
        const popupContent = $(this.selectors.compare.popup).find('.compare-content');
        popupContent.html(this.stripScripts(html));
        this.rteWrap(this.selectors.compare.popup + ' .rte');
        this.convertCurrencySilence(popupContent.find('span.money'));
        this.reLoadReview(popupContent);
        this.data.compare.firstLoaded = true;
        if(cb) {
          cb();
        }
      });
    });
  },

  afterUpdatedVariantCompare: function(selectVariant) {
    const selector = this.selectors.productGroup,
      index = selectVariant.attr('data-index'),
      pg = selectVariant.parents(selector.wrap),
      table = selectVariant.parents('table'),
      variantId = selectVariant.val();
    const option = selectVariant.children('option:selected');
    const available = option.attr('data-available');
    const priceCol = table.find('td[data-index="' + index + '"] ' + selector.price);
    if(variantId) {
      selectVariant.parent().removeClass(selector.requiredOptionsClass);
      const variant = {
        available: available,
        inventory_policy: option.attr('data-inventory-policy'),
        inventory_quantity: parseInt(option.attr('data-inventory-quantity') || 0)
      };
      this.updateCartBtn(pg, variant)
    } else {
      this.updateCartBtn(pg)
    }
    if(available) {
      pg.find(selector.cartBtn).removeClass('soldout').removeAttr('disabled');
    } else {
      pg.find(selector.cartBtn).addClass('soldout').attr('disabled', 'disabled');
    }
    pg.find(selector.variantId).val(variantId);
    
    priceCol.html(this.getPriceTagHtml(parseInt(option.data('price')), parseInt(option.data('compare-price'))));
    this.convertCurrencySilence(priceCol.find('span.money'));

    if(option.data('featured-image') != undefined) {
      const img = table.find('td[data-index="' + index + '"] ' + selector.mainImg);
      img.parent(':not(.not-loading)').addClass('loading');
      img.attr('data-src', this.resizeImage(option.data('featured-image'), img.attr('data-image-size')).replace('_1x1.', '_{width}x.'));
      img.addClass('lazyload');
    }
    priceCol.parent().find(this.selectors.compare.bestPriceBadge).attr('data-price', option.data('price'));
  },

  initCompareEvent: function() {
    const workingClass = 'working', selector = this.selectors.compare, cookieName = this.options.compare.cookieName;
    $(selector.number).text(this.getCookieItemsValue(true, cookieName).length);
    $(document).on('click', selector.btn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      const id = btn.attr('data-id');
      if(this.isProductExistInCookie(id, cookieName) && $(this.selectors.compare.popup).find('table').length > 0) {
        this.showPopup(this.selectors.compare.popup);
      } else {
        this.addProductToCookie(id, cookieName);
        $(selector.number).text(this.getCookieItemsValue(true, cookieName).length);
        this.startLoadingBtn(btn);
        this.loadCompare(() => {
          this.endLoadingBtn(btn);
          this.showPopup(this.selectors.compare.popup);
        });  
      }
    });

    $(document).on('click', selector.removeBtn, (e) => {
      e.preventDefault();
      const id = $(e.currentTarget).attr('data-id');
      this.removeProductFromCookie(id, cookieName);
      $(selector.number).text(this.getCookieItemsValue(true, cookieName).length);
      this.loadCompare();
    });

    $(document).on('click', selector.headerLink, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass(workingClass)) {
        return;
      }
      btn.addClass(workingClass);
      if(this.firstLoaded) {
        this.showPopup(this.selectors.compare.popup);
        btn.removeClass(workingClass);
      } else {
        this.showLoadingFull();
        this.loadCompare(() => {
          this.hideLoadingFull();
          this.showPopup(this.selectors.compare.popup);
          btn.removeClass(workingClass);
        });  
      }
    });
    $(document).on('change', selector.variantId, (e) => {
      this.afterUpdatedVariantCompare($(e.currentTarget));
    });
  },

  loadDynamicProductsAjax: function(params, page, cb) {
    var data = {
      'view': 'dynamic_ajax',
      'q': params,
      'page': page
    }
    this.callAjax(theme.rootUrl, 'GET', data, null, cb);
  },

  addProductMetaData: function(wrap, inAjax) {
    if(inAjax) {
      this.convertCurrencySilence(wrap.find('span.money'));
      this.reLoadReview(wrap);
    }
    this.initDealCountdown(wrap);
    this.popularAddedWishlistItems(wrap);
  },

  afterLoadDynamicProductsAjaxInTab: function(parent, html) {
    parent.removeClass(this.selectors.waitingData.replace('.',''));
    parent.append($('.products', html).html());
    
    var loadMoreBtn = parent.siblings(this.selectors.loadMoreBtn);
    if(loadMoreBtn.length > 0) {
      loadMoreBtn.remove();
    }
    if($(this.selectors.loadMoreBtn, html).length > 0) {
      parent.parent().append($(this.selectors.loadMoreBtn, html).get(0).outerHTML);
    }
  },

  destroyInfiniteScroll: function(idSave) {
    if(typeof this.data.productGroupInfiniteScroll[idSave] != 'undefined') {
      $.each(this.data.productGroupInfiniteScroll[idSave], (index, obj) => {
        obj.destroy();
      });
    }
  },

  initInfiniteScroll: function(wrap) {
    const wrapObj = this.convertStrToObject(wrap);
    if(wrapObj.find(this.selectors.infiniteScroll.button).length > 0) {
      this.loadCssJsLib('waypoint', () => {
        this.loadCssJsLib('infinite', () => {
          wrapObj.find(this.selectors.infiniteScroll.button).each((index, btnEle) => {
            const btn = $(btnEle);
            const dataIdSave = btn.attr('data-id-save');
            if(typeof this.data.productGroupInfiniteScroll[dataIdSave] == 'undefined') {
              this.data.productGroupInfiniteScroll[dataIdSave] = [];
            }
            const element = btn.siblings('.products').first();
            const dataId = btn.attr('data-id');
            this.data.productGroupInfiniteScroll[dataIdSave].push(new Waypoint.Infinite({
              element: element,
              items: '.grid__item',
              more: dataId,
              onAfterPageLoad: ($items) => {
                BtCurrency.convertSilence(shopCurrency, BtCurrency.currentCurrency, $items.find('span.money'));
                this.initDealCountdown($items);
                this.reLoadReview($items);
              }
            }));  
          }); 
        });  
      });
    }
  },

  invertColor: function(hex, bw) {
      if (hex.indexOf('#') === 0) {
          hex = hex.slice(1);
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
          hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      if (hex.length !== 6) {
        return false;
      }
      var r = parseInt(hex.slice(0, 2), 16),
          g = parseInt(hex.slice(2, 4), 16),
          b = parseInt(hex.slice(4, 6), 16);
      if (bw) {
          // http://stackoverflow.com/a/3943023/112731
          return (r * 0.299 + g * 0.587 + b * 0.114) > 186
              ? '#000000'
              : '#FFFFFF';
      }
      // invert color components
      r = (255 - r).toString(16);
      g = (255 - g).toString(16);
      b = (255 - b).toString(16);
      // pad each with zeros and return
      return "#" + this.padZero(r) + this.padZero(g) + this.padZero(b);
  },

  padZero: function(str, len) {
    len = len || 2;
    const zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
  },




  initLoadMoreBtn: function() {
    $(document).on('click', this.selectors.loadMoreBtn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass(this.selectors.workingClass)) {
        return;
      }
      btn.addClass(this.selectors.workingClass).prepend('<i class="' + this.selectors.loadingAjaxClass + '" style="margin-right: 5px;"></i>');
      const href = btn.attr('data-href');
      const parent = btn.siblings('.grid');
      if(href == undefined) {
        this.loadDynamicProductsAjax(btn.attr('data-ajax-params'), 2, (html) => {
          this.afterLoadDynamicProductsAjaxInTab(parent, html);
          this.addProductMetaData(parent, true);
        });
      } else {
        this.callAjax(href, 'GET', null, null, (html) => {
          this.afterLoadDynamicProductsAjaxInTab(parent, html);
          this.addProductMetaData(parent, true);
        });
      }
    });
  },

  updateThresholdMenu: function(addtionalHeight) {
    this.data.thresholdMenu += addtionalHeight;
  },

  calculateThresholdAndFixSticker: function() {
    const height = this.data.stickyMenuObj.outerHeight();
    this.data.thresholdMenu = this.data.stickyMenuObj.offset().top + height;
    this.fixedHeightSticker(height);
  },

  updateStickyMenuObj: function(obj) {
    if(obj.hasClass('use-sticky')) {
      this.data.stickyMenuObj = obj;
    } else {
      this.data.stickyMenuObj = obj.parents('.use-sticky').first();
    }
  },

  openStickyMenu: function() {
    if($(window).scrollTop() > this.data.thresholdMenu) {
      if(!this.data.stickyMenuObj.hasClass('active')) {
        this.data.stickyMenuObj.addClass('active');
      }
    } else {
      this.hideStickyMenu();
    }
  },

  hideStickyMenu: function() {
    if(this.data.stickyMenuObj.hasClass('active') && !$('body').hasClass('open-search-suggest')) {
      this.data.stickyMenuObj.removeClass('active');
    } 
  },

  fixedHeightSticker: function(height) {
    this.data.sticker.height(height);
  },

  initStickyMenu: function() {
    if(!$('.use-sticky').length) {
      return;
    }
    let obj = $('.use-sticky--desktop');
    if(this.data.cacheWindowWidth < 992) {
      obj = $('.use-sticky--mobile');
    }
    this.data.sticker = $('.header-sticker');
    this.data.stickyMenuObj = $('.header-sticker__inner')
    // this.updateStickyMenuObj(obj);
    this.calculateThresholdAndFixSticker();
    $(window).on(this.data.scrollEventName, (e, direction) => {
      if(this.data.pageLoaded && this.data.updatingProductOptions == false) {
        if(direction == 'down' && this.data.openingDesktopNav == false) {
          this.hideStickyMenu();
        } else {
          this.openStickyMenu();
        }
      }
    });
    $(window).on(this.data.resizeEventName, (e) => {
      // if(ins.data.cacheWindowWidth < 992) {
      //   obj = $('.use-sticky--mobile').removeClass('active');
      // } else {
      //   obj = $('.use-sticky--desktop').removeClass('active');
      //   obj = $('.use-sticky--desktop');
      //   obj.parents('.use-sticky').removeClass('active');
      // }
      // ins.updateStickyMenuObj(obj);
      this.calculateThresholdAndFixSticker();
    });
  },

  initRecommendedProducts: function() {
    if(!theme.enableRecommendedProducts) {
      return;
    }
    
    setTimeout(() => {
      const cookieName = this.options.rp.cookieName;
      const cookie = this.getCookie(cookieName);
      if(cookie != undefined) {
        return;
      }
      this.loadCssJsLib('recommendedProducts');
    }, 8000);
  },

  initNewsTerms: function(wrap) {
    if(!theme.newsTerms) {
      return;
    }
    const form = $(wrap + ' ' + this.selectors.newsTerms.form),
      input = $(wrap + ' ' + this.selectors.newsTerms.input),
      cookieName = this.options.newsTerms.cookieName,
      cookieValue = this.getCookie(cookieName);
    
    form.unbind('submit');
    input.unbind('change');
    if(cookieValue == '1') {
      input.attr('checked','checked');
    }

    input.on('change', (e) => {
      if($(e.currentTarget).is(':checked')) {
        this.setCookie(cookieName, 1);
      } else {
        this.setCookie(cookieName, 0);
      }
    });

    form.on('submit', (e) => {
      if(!input.is(':checked')) {
        e.preventDefault();
      }
    })
  },

  initNewsletterPopup: function() {
    if(!theme.enableNewsPopup || location.hash.substr(1) == 'newsletter-popup-form') {
      return;
    }
    setTimeout(() => {
      if(this.isWebsiteBusy()) {
        return;
      }
      this.loadCssJsLib("newsletterPopup");
    }, 8000);
  },

  initBackTopButton: function() {
    var $backTop = $('.back-top__button');
    if($backTop.length){
      $(document).on('click', '.back-top__button', () => {
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });
    }
  },

  initCookieConsent: function() {
    if(!theme.enableCookieConsent || this.isWebsiteBusy()) {
      return;
    }
    setTimeout(() => {
      const cookieName = 'cookie_consent';
      const cookie = this.getCookie(cookieName);
      if(cookie != undefined) {
        return;
      }
      this.loadSnippetAjax('cookie-consent', () => {
        if(!this.isWebsiteBusy() && $('.cookie_consent').length > 0) {
          $('.cookie_consent').slideDown(300);
          $(document).on('click', '.cookie_consent__close', (e) => {
            e.preventDefault();
            this.setCookie(cookieName, 1, 365);
            $('.cookie_consent').slideUp(300);
          });
        }
      });
    }, 9000);
  },

  initPopupVideo: function() {
    const selector = this.selectors.popupVideo;
    $(document).on('click', selector.btn, (e) => {
      e.preventDefault();
      if(this.data.modalVideoWorking) {
        return;
      }
      const btn = $(e.currentTarget);
      new Promise((resolve, reject) => {
        this.data.modalVideoWorking = true;
        if(theme.loadedLibs.indexOf('modalvideo') > -1) {
          resolve(btn);
        } else {
          this.loadCssJsLib('modalvideo', () => {
            $(selector.youtubeBtn).modalVideo();
            $(selector.vimeoBtn).modalVideo({channel:'vimeo'});
            resolve(btn);
          });
        }
      }).then(() => {
        this.data.modalVideoWorking = false;
        const videoId = btn.attr('data-video-id');
        const videoType = btn.attr('data-video-type');
        if(videoType == 'youtube') {
          $(selector.youtubeBtn).attr('data-video-id', videoId);
          $(selector.youtubeBtn).trigger('click');
        } else {
          $(selector.vimeoBtn).attr('data-video-id', videoId);
          $(selector.vimeoBtn).trigger('click');
        }
      }, (err) => {
        // console.log(err);
      });
    });
  },

  loadWishlist: function(cb) { 
    const selector = this.selectors.wishlist, cookieName = this.options.wishlist.cookieName;
    const cookieValue = this.getCookieItemsValue(true, cookieName);
    if(cookieValue == '' || cookieValue == undefined) {
      this.loadSnippetAjax('popup-wishlist', () => {
        const popupContent = $(selector.popup).find('.content');
        this.appendWishlistEmtptyStr(popupContent);
        this.data.wishlist.loaded = true;
        if(cb) {
          cb();
        }
      });
    } else {
      this.callAjax(theme.searchUrl, 'GET', {view: 'wishlist', q: this.getQueryByIds(cookieValue), type: 'product'}, null, (html) => {
        this.loadSnippetAjax('popup-wishlist', () => {
          const popupContent = $(selector.popup).find('.content');
          popupContent.html(this.stripScripts(html));
          if(!popupContent.hasClass('grid')) {
            popupContent.addClass('grid grid--medium')
          }
          this.convertCurrencySilence(popupContent.find('span.money'));
          this.reLoadReview(popupContent);
          this.data.wishlist.loaded = true;
          if(cb) {
            cb();
          }
        });
      });
    }
  },

  popularAddedWishlistItems: function(wrap){
    if(!theme.enableWishlist){
      return;
    }
    const wrapObj = this.convertStrToObject(wrap);
    const selector = this.selectors.wishlist, cookieName = this.options.wishlist.cookieName;
    let btnSelector = '', textSelector = '';
    const items = this.getCookieItemsValue(true, cookieName);
    if(items.length > 0) {
     $.each(items, (index, value) => {
        if(btnSelector != '') {
          btnSelector += ',';
          textSelector += ',';
        }
        btnSelector += selector.btn + '[data-id="' + value + '"]';
        textSelector += selector.btnWithText + '[data-id="' + value + '"] ' + selector.btnText;
      });
    }
    wrapObj.find(btnSelector).addClass('added').attr('title', theme.strings.addedWishlistTitle);
    wrapObj.find(textSelector).text(theme.strings.addedWishlistTitle);
  },

  appendWishlistEmtptyStr: function(popupContent) {
    popupContent.removeClass('grid grid--medium')
    popupContent.html('<div class="alert alert-warning"><span>' + theme.strings.wishlistEmpty +'</span></div>');
  },

  initWishlist: function() {
    if(!theme.enableWishlist){
      return;
    }
    const selector = this.selectors.wishlist, cookieName = this.options.wishlist.cookieName;
    const items = this.getCookieItemsValue(true, cookieName);
    const workingClass = 'working';
    this.popularAddedWishlistItems('body');
    $(selector.number).text(items.length);
    $(document).on('click', selector.btn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      const id = btn.attr('data-id');
      if(this.isProductExistInCookie(id, cookieName)) {
        this.removeProductFromCookie(id, cookieName);
        $(selector.btn + '[data-id="' + id + '"]').removeClass('added').attr('title', theme.strings.addWishlistTitle);
        $(selector.btnWithText + '[data-id="' + id + '"] ' + selector.btnText).text(theme.strings.addWishlistTitle);
      } else {
        this.addProductToCookie(id, cookieName);
        $(selector.btn + '[data-id="' + id + '"]').addClass('added').attr('title', theme.strings.addedWishlistTitle);
        $(selector.btnWithText + '[data-id="' + id + '"] ' + selector.btnText).text(theme.strings.addedWishlistTitle);
      }
      $(selector.number).text(this.getCookieItemsValue(true, cookieName).length);
      this.data.wishlist.loaded = false;
      $(selector.headerLink + ' i').addClass(this.selectors.ringClass);
    });

    $(document).on('click', selector.removeBtn, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      var id = btn.attr('data-id');
      this.removeProductFromCookie(id, cookieName);
      $(selector.number).text(this.getCookieItemsValue(true, cookieName).length);
      $(selector.btn + '[data-id="' + id + '"]').removeClass('added').attr('title', theme.strings.addWishlistTitle);
      $(selector.btnWithText + '[data-id="' + id + '"] ' + selector.btnText).text(theme.strings.addWishlistTitle);
      btn.closest('.item').remove();
      // $(selector.popup + ' .item[data-product-id="' + id + '"]').remove();
      if($(selector.popup).find('.item').length == 0) {
        var popupContent = $(selector.popup).find('.content');
        this.appendWishlistEmtptyStr(popupContent);
      }
    });

    $(document).on('click', selector.headerLink, (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass(workingClass)) {
        return;
      }
      btn.addClass(workingClass);
      if(this.data.wishlist.loaded) {
        this.showPopup(selector.popup);
        btn.removeClass(workingClass);
      } else {
        this.showLoadingFull();
        this.loadWishlist(() => {
          this.hideLoadingFull();
          this.showPopup(selector.popup);
          btn.removeClass(workingClass);
        });  
      }
    });
  },

  initExpandTrigger: function() {
    const workingClass = 'working';
    $(document).on('click', '.expand-trigger', (e) => {
      e.preventDefault();
      const btn = $(e.currentTarget);
      if(btn.hasClass('working')) {
        return;
      }
      btn.addClass('working');
      var effect = "slideDown";
      if(btn.hasClass('open')) {
        effect = "slideUp";
      }
      btn.toggleClass('open');
      const content = btn.attr('href') == '#' ? btn.siblings('.expand-content') : $(btn.attr('href'));
      if(effect == 'slideDown') {
       content.slideDown(300, () => {
          btn.removeClass(workingClass);
        });
      } else {
       content.slideUp(300, () => {
          btn.removeClass(workingClass);
        });
      }
    });
  },

  initResizeWindowTrigger: function() {
    this.data.cacheWindowWidth = $(window).width();
    $(window).resize($.debounce( 250, (e) => {
      const wwidth = $(window).width();
      if(this.data.cacheWindowWidth!==wwidth){
        this.data.cacheWindowWidth = $(window).width();
        $(window).trigger(this.data.resizeEventName);
      }
    }));
  },

  initScrollingWindow: function() {
    let lastScrollTop = 0;
    $(window).scroll($.throttle(100, (e) => {
      const st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
      if (st > lastScrollTop){
        $(window).trigger(this.data.scrollEventName, ['down']);
      } else {
        $(window).trigger(this.data.scrollEventName, ['up']);
      }
      lastScrollTop = st <= 0 ? 0 : st;
    }));
    $(window).on(this.data.resizeEventName, (e) => {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      lastScrollTop = st <= 0 ? 0 : st;  
    });
  },

  initScrollingWindowTriggerOnce: function(ele, suffixEvent, additionalOffset, cb) {
    additionalOffset = (additionalOffset != undefined) ? additionalOffset : 0;
    var offset = ele.offset().top + additionalOffset;
    if(window.pageYOffset + window.innerHeight > offset) {
      cb();
    } else {
      var runCb = false, event = 'scroll.' + suffixEvent, resizeEvent = this.data.resizeEventName + '.scroll_' + suffixEvent;
      $(window).on(event, $.throttle( 250, (e) => {
        if(window.pageYOffset + window.innerHeight > offset) {
          $(window).off(event);
          $(window).off(resizeEvent);
          if(!runCb) {
            runCb = true;
            cb();
          }
        }
      }));
      $(window).on(resizeEvent , () => {
        if(runCb) {
          $(window).off(resizeEvent);
          return;
        }
        setTimeout(() => {
          offset = ele.offset().top + additionalOffset;
          if(window.pageYOffset + window.innerHeight > offset) {
            $(window).off(event);
            $(window).off(resizeEvent);
            if(!runCb) {
              runCb = true;
              cb();
            }
          }
        }, 300);
      });
    }
  },

  destroyScrollingWindowTriggerOnce: function(suffixEvent) {
    $(window).off('scroll.' + suffixEvent);
    $(window).off(this.data.resizeEventName + '.scroll_' + suffixEvent);
  },

  renderColumnsAjaxLoading: function(wrap, limit) {
    var template = '<div class="pcol__item item dib w100 gutter-ele-bottom"><div class="flex flex-wrap flex-align-space-between"><div class="pcol__item__left col-xs-4 no-gutter--left"><div class="item__image img-container loading" style="padding-top:130%;"></div></div><div class="pcol__item__right col-xs-8 no-gutter"><span class="db w100 loading" style="height:20px;"></span><div class="gutter-ele-top"><span class="db w100 loading" style="height:20px;"></span></div><div class="gutter-ele-top"><span class="db w100 loading" style="height:20px;"></span></div></div></div></div>';
    var items = '';
    var i = 0;
    for(i; i < limit; i++) {
      items += template;
    }
    wrap.html(items);
  },

  loadProductColumnsAjax: function($container) {
    const workingClass = 'working';
    if($container.hasClass('load-product-columns-ajax')) {
      this.loadCssJsLib('waypoint', () => {
        var wp = $container.waypoint((direction) => {
          if($container.hasClass(workingClass)) {
            return;
          }
          wp[0].destroy();
          $container.addClass(workingClass);
          $container.find('.pcol__items').each((indexCol, pcolEle) => {
            this.renderColumnsAjaxLoading($(pcolEle), parseInt($(pcolEle).attr('data-limit')));
          });
          this.renderSectionByAjaxApi($container.attr('data-section-id'), {}, (htmlResponse) => {
            $container.find('.pcol__items').each((indexCol, pcolEle) => {
              $(pcolEle).html($('#' + $(pcolEle).attr('id'), htmlResponse).html());
              $(pcolEle).removeClass('waiting-data');
            });
            this.addProductMetaData($container, true);
            this.initSlider($container, false, false);
          });
        }, {
          triggerOnce: true,
          offset: '100%'
        });
      });
    }
  },

  addProductRecentView: function(productId) {
    if(!theme.enableRecentView) {
      return;
    }
    this.addProductToCookie(productId, this.options.recentView.cookieName);
  },

  loadRequireCss: function() {
    if(theme.requireCss.length > 0) {
      $(theme.requireCss).each((index, value) => {
        this.loadCssJsLib(value);
      });
    }
  },

  initProductCustomFields: function() {
    $(document).on('change', '.pg__field__ele', (e) => {
      const field = $(e.currentTarget);
      const targetEle = $(field.attr('data-target'));
      if(targetEle.hasClass('pg__field__group-checkbox')) {
        // Collect values
        let values = [];
        field.parents('.pg__field').find('.pg__field__ele').each(function(index, pgFieldEle) {
          if($(pgFieldEle).is(':checked')) {
            values.push($(pgFieldEle).val());
          }
        });
        targetEle.val(values.join(', '));
      } else {
        if(field.is(':checked')) {
          targetEle.prop('checked', true);
        } else {
          targetEle.prop('checked', false);
        }
      }
      targetEle.valid();
    });
    $(document).on('click', '.pg__field__radio', (e) => {
      const targetEle = $($(e.currentTarget).attr('data-target'));
      targetEle.val($(e.currentTarget).val());
      targetEle.valid();
    });
  },

  initModalLink: function() {
    $(document).on('click', '.modal-link', (e) => {
      e.preventDefault();
      this.showPopup($(e.currentTarget).attr('data-target'));
    });
  },

  initPopupAccount: function() {
    $(document).on('show.bs.modal', '#accountPopup', () => {
      if($('#accountPopup .field__input').length > 0) {
        setTimeout(() => {
          $('#accountPopup .field__input').first().focus();
        }, 500);
      }
    });
  },

  initRecentlyViewed: function() {
    if(theme.enableRecentView) {
      BT.loadCssJsLib('recently-viewed');
    }
  },
  
  init: function() {
    this.initMobileNavigation();
    this.initSearchSuggestion();
    this.initResizeWindowTrigger();
    this.initScrollingWindow();
    this.initDropdown();
    this.initProductGroup();
    this.initCartEvent();
    this.initQtyBox();
    this.initTabsCallback();
    this.initQuickView();
    this.initSelectOption();
    this.initCompareEvent();
    this.initWishlist();
    this.initLoadMoreBtn();
    this.initRecommendedProducts();
    this.initNewsletterPopup();
    this.initCookieConsent();
    this.initExpandTrigger();
    this.initOverlay();
    this.initModalLink();
    this.rteWrap('body .rte');
    this.initPopupAccount();
    this.initRecentlyViewed();
    setTimeout(() => {
      this.updateFaviconBadge(theme.cartNumber);
      this.initBackTopButton();
      this.initAgreeCartTems();
      this.initPopupVideo();
      this.initProductCustomFields();
    }, 500);
    if(theme.disableCopy) {
      document.addEventListener('contextmenu', function(event){ event.preventDefault(); }); 
    }
    $(document).one('touchstart', () => {
      this.data.isTouchDevide = true;
    });
    this.initSidebar();
    setTimeout(() => {
      this.data.pageLoaded = true;
      this.initStickyMenu();
    }, 500);
  }
};
class BTSection {
  constructor(container, sectionId, type) {
    this.container = container;
    this.sectionId = sectionId;
    this.type = type;
    this.onInit();
  }

  onInit() {

  }

  onLoad(evt) {

  }

  onUnload(evt) {

  }

  onSelect(evt) {

  }

  onDeselect(evt) {

  }

  onBlockSelect(evt) {

  }

  onBlockDeselect(evt) {

  }
}